// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1ZFPP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _alertDialog = require("tailwind-starter/AlertDialog");
var _button = require("tailwind-starter/Button");
var _checkbox = require("tailwind-starter/Checkbox");
var _lucideReact = require("lucide-react");
var _reactAriaComponents = require("react-aria-components");
var _dialog = require("tailwind-starter/Dialog");
var _menu = require("tailwind-starter/Menu");
var _modal = require("tailwind-starter/Modal");
var _plants = require("./plants");
var _plantsDefault = parcelHelpers.interopDefault(_plants);
var _popover = require("tailwind-starter/Popover");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchField = require("tailwind-starter/SearchField");
var _tagGroup = require("tailwind-starter/TagGroup");
var _tooltip = require("tailwind-starter/Tooltip");
var _reactAria = require("react-aria");
var _labels = require("./Labels");
var _plantTable = require("./PlantTable");
var _plantDialog = require("./PlantDialog");
var _plantList = require("./PlantList");
"use client";
function App() {
    let [allItems, setAllItems] = (0, _react.useState)(()=>(0, _plantsDefault.default).map((p)=>({
                ...p,
                isFavorite: false
            })));
    let [sortDescriptor, setSortDescriptor] = (0, _react.useState)({
        column: 'common_name',
        direction: 'ascending'
    });
    let [visibleColumns, setVisibleColumns] = (0, _react.useState)(new Set([
        'favorite',
        'common_name',
        'sunlight',
        'watering',
        'actions'
    ]));
    // Filter state.
    let [search, setSearch] = (0, _react.useState)('');
    let [favorite, setFavorite] = (0, _react.useState)(false);
    let [cycles, setCycles] = (0, _react.useState)(new Set());
    let [sunlight, setSunlight] = (0, _react.useState)(new Set());
    let [watering, setWatering] = (0, _react.useState)(new Set());
    // Filter and sort items.
    let { contains } = (0, _reactAria.useFilter)({
        sensitivity: 'base'
    });
    let collator = (0, _reactAria.useCollator)();
    let dir = sortDescriptor.direction === 'descending' ? -1 : 1;
    let items = allItems.filter((item)=>(contains(item.common_name, search) || contains(item.scientific_name.join(''), search)) && (!favorite || item.isFavorite) && (cycles === 'all' || cycles.size === 0 || cycles.has(item.cycle)) && (sunlight === 'all' || sunlight.size === 0 || sunlight.has((0, _labels.getSunlight)(item))) && (watering === 'all' || watering.size === 0 || watering.has(item.watering))).sort((a, b)=>collator.compare(a[sortDescriptor.column], b[sortDescriptor.column]) * dir);
    // Count applied filters for button badge.
    let filters = 0;
    if (favorite) filters++;
    if (cycles !== 'all') filters += cycles.size;
    if (sunlight !== 'all') filters += sunlight.size;
    if (watering !== 'all') filters += watering.size;
    let clearFilters = ()=>{
        setFavorite(false);
        setCycles(new Set());
        setSunlight(new Set());
        setWatering(new Set());
    };
    // Toggle whether an item is a favorite.
    let onFavoriteChange = (id, isFavorite)=>{
        setAllItems((allItems)=>{
            let items = [
                ...allItems
            ];
            let index = items.findIndex((item)=>item.id === id);
            items[index] = {
                ...items[index],
                isFavorite
            };
            return items;
        });
    };
    // Add, edit, and delete items.
    let addItem = (item)=>{
        setAllItems((allItems)=>[
                ...allItems,
                item
            ]);
    };
    let editItem = (item)=>{
        setAllItems((allItems)=>{
            let items = [
                ...allItems
            ];
            let index = items.findIndex((i)=>i.id === item.id);
            items[index] = item;
            return items;
        });
    };
    let deleteItem = ()=>{
        setAllItems((allItems)=>{
            if (!actionItem) return allItems;
            let items = [
                ...allItems
            ];
            let index = items.findIndex((item)=>item.id === actionItem.id);
            items.splice(index, 1);
            return items;
        });
    };
    let [dialog, setDialog] = (0, _react.useState)(null);
    let [actionItem, setActionItem] = (0, _react.useState)(null);
    let onEdit = (item)=>{
        setDialog('edit');
        setActionItem(item);
    };
    let onDelete = (item)=>{
        setDialog('delete');
        setActionItem(item);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-4 p-4 max-w-[600px] mx-auto",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid grid-cols-[1fr_auto_auto] sm:grid-cols-[1.1fr_auto_auto_1fr_auto] gap-2 items-end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchField.SearchField), {
                        "aria-label": "Search",
                        value: search,
                        onChange: setSearch,
                        className: "col-span-3 sm:col-span-1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TooltipTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        "aria-label": "Filters",
                                        variant: "secondary",
                                        className: "w-9 h-9 shrink-0 p-0 px-2 relative",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FilterIcon), {
                                                "aria-hidden": true,
                                                className: "block w-5 h-5"
                                            }),
                                            filters > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "absolute -top-2 -right-2 rounded-full h-4 aspect-square text-white text-xs bg-blue-600",
                                                children: filters
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
                                        children: "Filters"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                                showArrow: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.Dialog), {
                                    className: "outline outline-0 p-4 max-h-[inherit] overflow-auto w-[350px]",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                                            slot: "title",
                                            className: "text-lg font-semibold m-0 mb-2",
                                            children: "Filters"
                                        }),
                                        filters > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            onPress: clearFilters,
                                            variant: "secondary",
                                            className: "absolute top-4 right-4 py-1 px-2 text-xs",
                                            children: "Clear"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex flex-col gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                    isSelected: favorite,
                                                    onChange: setFavorite,
                                                    children: "Favorite"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
                                                    label: "Cycle",
                                                    selectionMode: "multiple",
                                                    selectedKeys: cycles,
                                                    onSelectionChange: setCycles,
                                                    escapeKeyBehavior: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Annual",
                                                            color: "green",
                                                            textValue: "Annual",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                                    className: "w-4 h-4 shrink-0"
                                                                }),
                                                                " Annual"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Perennial",
                                                            color: "green",
                                                            textValue: "Perennial",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                                    className: "w-4 h-4 shrink-0"
                                                                }),
                                                                " Perennial"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
                                                    label: "Sunlight",
                                                    selectionMode: "multiple",
                                                    selectedKeys: sunlight,
                                                    onSelectionChange: setSunlight,
                                                    escapeKeyBehavior: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "full sun",
                                                            color: "yellow",
                                                            textValue: "Full Sun",
                                                            children: [
                                                                (0, _labels.sunIcons)['full sun'],
                                                                " Full Sun"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "part sun",
                                                            color: "yellow",
                                                            textValue: "Part Sun",
                                                            children: [
                                                                (0, _labels.sunIcons)['part sun'],
                                                                " Part Sun"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "part shade",
                                                            color: "yellow",
                                                            textValue: "Part Shade",
                                                            children: [
                                                                (0, _labels.sunIcons)['part shade'],
                                                                " Part Shade"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
                                                    label: "Watering",
                                                    selectionMode: "multiple",
                                                    selectedKeys: watering,
                                                    onSelectionChange: setWatering,
                                                    escapeKeyBehavior: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Frequent",
                                                            color: "blue",
                                                            textValue: "Frequent",
                                                            children: [
                                                                (0, _labels.wateringIcons)['Frequent'],
                                                                " Frequent"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Average",
                                                            color: "blue",
                                                            textValue: "Average",
                                                            children: [
                                                                (0, _labels.wateringIcons)['Average'],
                                                                " Average"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
                                                            id: "Minimum",
                                                            color: "blue",
                                                            textValue: "Minimum",
                                                            children: [
                                                                (0, _labels.wateringIcons)['Minimum'],
                                                                " Minimum"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TooltipTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        "aria-label": "Columns",
                                        variant: "secondary",
                                        className: "w-9 h-9 shrink-0 p-0 hidden sm:block",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.SlidersIcon), {
                                            "aria-hidden": true,
                                            className: "block w-5 h-5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
                                        children: "Columns"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
                                selectionMode: "multiple",
                                selectedKeys: visibleColumns,
                                onSelectionChange: setVisibleColumns,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                        id: "common_name",
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                        id: "cycle",
                                        children: "Cycle"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                        id: "sunlight",
                                        children: "Sunlight"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                        id: "watering",
                                        children: "Watering"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                "aria-label": "Add plant",
                                variant: "secondary",
                                className: "w-9 h-9 shrink-0 p-0 col-start-5",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.PlusIcon), {
                                    "aria-hidden": true,
                                    className: "block w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _plantDialog.PlantDialog), {
                                    onSave: addItem
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _plantList.PlantList), {
                items: items,
                onFavoriteChange: onFavoriteChange,
                onEdit: onEdit,
                onDelete: onDelete
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _plantTable.PlantTable), {
                sortDescriptor: sortDescriptor,
                onSortChange: setSortDescriptor,
                visibleColumns: visibleColumns,
                items: items,
                onFavoriteChange: onFavoriteChange,
                onEdit: onEdit,
                onDelete: onDelete
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                isOpen: dialog === 'delete',
                onOpenChange: ()=>setDialog(null),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alertDialog.AlertDialog), {
                    title: "Delete Plant",
                    variant: "destructive",
                    actionLabel: "Delete",
                    onAction: deleteItem,
                    children: [
                        'Are you sure you want to delete "',
                        actionItem?.common_name,
                        '"?'
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                isOpen: dialog === 'edit',
                onOpenChange: ()=>setDialog(null),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _plantDialog.PlantDialog), {
                    item: actionItem,
                    onSave: editItem
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/AlertDialog":"9KkEN","tailwind-starter/Button":"hk9LL","tailwind-starter/Checkbox":"9J9Ug","lucide-react":[["FilterIcon","7C0UI","default"],["PlusIcon","d6evu","default"],["RefreshCw","2oAid","default"],["SlidersIcon","3FWGC","default"]],"react-aria-components":[["DialogTrigger","l2uUY"],["Heading","2f4nH"],["TooltipTrigger","fLMVd"]],"tailwind-starter/Dialog":"cRN3c","tailwind-starter/Menu":"iPFGc","tailwind-starter/Modal":"2GPV8","./plants":"2Wr3I","tailwind-starter/Popover":"Dr9D3","react":"a1TxN","tailwind-starter/SearchField":"f0WdN","tailwind-starter/TagGroup":"9wXZT","tailwind-starter/Tooltip":"4lonv","react-aria":[["useCollator","aohjl"],["useFilter","eUaoA"]],"./Labels":"5mUiz","./PlantTable":"5iWC0","./PlantDialog":"bfd4s","./PlantList":"3Y0eO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9KkEN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertDialog", ()=>AlertDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAria = require("react-aria");
var _reactAriaComponents = require("react-aria-components");
var _button = require("./Button");
var _dialog = require("./Dialog");
'use client';
function AlertDialog({ title, variant, cancelLabel, actionLabel, onAction, children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
        role: "alertdialog",
        ...props,
        children: ({ close })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                        slot: "title",
                        className: "text-xl font-semibold leading-6 my-0",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `w-6 h-6 absolute right-6 top-6 stroke-2 ${variant === 'destructive' ? 'text-red-500' : 'text-blue-500'}`,
                        children: variant === 'destructive' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertCircleIcon), {
                            "aria-hidden": true
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.InfoIcon), {
                            "aria-hidden": true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mt-3 text-slate-500 dark:text-zinc-400",
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-6 flex justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "secondary",
                                onPress: close,
                                children: cancelLabel || 'Cancel'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: variant === 'destructive' ? 'destructive' : 'primary',
                                autoFocus: true,
                                onPress: (0, _reactAria.chain)(onAction, close),
                                children: actionLabel
                            })
                        ]
                    })
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["AlertCircleIcon","gpCZd","default"],["InfoIcon","bTmmM","default"]],"react":"a1TxN","react-aria":"ij7eS","react-aria-components":"2f4nH","./Button":"hk9LL","./Dialog":"cRN3c","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gpCZd":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CircleAlert);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const CircleAlert = (0, _createLucideIconJsDefault.default)("circle-alert", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gsSty":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"a1TxN","./shared/src/utils.js":"lfP1m","./Icon.js":"d0fsO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lfP1m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d0fsO":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"a1TxN","./defaultAttributes.js":"9Rm8m","./shared/src/utils.js":"lfP1m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Rm8m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bTmmM":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Info);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const Info = (0, _createLucideIconJsDefault.default)("info", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hk9LL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
let button = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'relative inline-flex items-center border-0 px-5 [&:has(svg:only-child)]:px-2 py-2 font-sans text-sm text-center transition rounded-lg border border-black/10 dark:border-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none cursor-default',
    variants: {
        variant: {
            primary: 'bg-blue-600 hover:bg-blue-700 pressed:bg-blue-800 text-white',
            secondary: 'bg-gray-50 hover:bg-gray-100 pressed:bg-gray-200 text-gray-800 dark:bg-zinc-600 dark:hover:bg-zinc-500 dark:pressed:bg-zinc-400 dark:text-zinc-100',
            destructive: 'bg-red-700 hover:bg-red-800 pressed:bg-red-900 text-white'
        },
        isDisabled: {
            true: 'bg-gray-100 dark:bg-zinc-800 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText] border-black/5 dark:border-white/5'
        },
        isPending: {
            true: 'text-transparent'
        }
    },
    defaultVariants: {
        variant: 'primary'
    }
});
function Button(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>button({
                ...renderProps,
                variant: props.variant,
                className
            })),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isPending })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    isPending && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": true,
                        className: "flex absolute inset-0 justify-center items-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            className: "w-4 h-4 text-white animate-spin",
                            viewBox: "0 0 24 24",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    strokeWidth: "4",
                                    fill: "none",
                                    className: "opacity-25"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    strokeWidth: "4",
                                    strokeLinecap: "round",
                                    fill: "none",
                                    pathLength: "100",
                                    strokeDasharray: "60 140",
                                    strokeDashoffset: "0"
                                })
                            ]
                        })
                    })
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"]],"tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jNXji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusRing", ()=>focusRing);
parcelHelpers.export(exports, "composeTailwindRenderProps", ()=>composeTailwindRenderProps);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
const focusRing = (0, _tailwindVariants.tv)({
    base: 'outline outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight] outline-offset-2',
    variants: {
        isFocusVisible: {
            false: 'outline-0',
            true: 'outline-2'
        }
    }
});
function composeTailwindRenderProps(className, tw) {
    return (0, _reactAriaComponents.composeRenderProps)(className, (className)=>(0, _tailwindMerge.twMerge)(tw, className));
}

},{"react-aria-components":"bA6Cz","tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cRN3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>Dialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
'use client';
function Dialog(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('outline outline-0 box-border p-6 [[data-placement]>&]:p-4 max-h-[inherit] overflow-auto relative', props.className)
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"l2uUY","tailwind-merge":"lEVAz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9J9Ug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroup", ()=>CheckboxGroup);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
function CheckboxGroup(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.CheckboxGroup), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col gap-2 font-sans'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: props.label
            }),
            props.children,
            props.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: props.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: props.errorMessage
            })
        ]
    });
}
const checkboxStyles = (0, _tailwindVariants.tv)({
    base: 'flex gap-2 items-center group font-sans text-sm transition relative',
    variants: {
        isDisabled: {
            false: 'text-gray-800 dark:text-zinc-200',
            true: 'text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    }
});
const boxStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'w-5 h-5 box-border shrink-0 rounded-sm flex items-center justify-center border-2 transition',
    variants: {
        isSelected: {
            false: 'bg-white dark:bg-zinc-900 border-(--color) [--color:var(--color-gray-400)] dark:[--color:var(--color-zinc-400)] group-pressed:[--color:var(--color-gray-500)] dark:group-pressed:[--color:var(--color-zinc-300)]',
            true: 'bg-(--color) border-(--color) [--color:var(--color-gray-700)] group-pressed:[--color:var(--color-gray-800)] dark:[--color:var(--color-slate-300)] dark:group-pressed:[--color:var(--color-slate-200)] forced-colors:[--color:Highlight]!'
        },
        isInvalid: {
            true: '[--color:var(--color-red-700)] dark:[--color:var(--color-red-600)] forced-colors:[--color:Mark]! group-pressed:[--color:var(--color-red-800)] dark:group-pressed:[--color:var(--color-red-700)]'
        },
        isDisabled: {
            true: '[--color:var(--color-gray-200)] dark:[--color:var(--color-zinc-700)] forced-colors:[--color:GrayText]!'
        }
    }
});
const iconStyles = 'w-4 h-4 text-white group-disabled:text-gray-400 dark:text-slate-900 dark:group-disabled:text-slate-600 forced-colors:text-[HighlightText]';
function Checkbox(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Checkbox), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>checkboxStyles({
                ...renderProps,
                className
            })),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isSelected, isIndeterminate, ...renderProps })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: boxStyles({
                            isSelected: isSelected || isIndeterminate,
                            ...renderProps
                        }),
                        children: isIndeterminate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Minus), {
                            "aria-hidden": true,
                            className: iconStyles
                        }) : isSelected ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                            "aria-hidden": true,
                            className: iconStyles
                        }) : null
                    }),
                    children
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["Check","9PYFQ","default"],["Minus","5Mlaw","default"]],"react":"a1TxN","react-aria-components":[["Checkbox","9jC2J"],["CheckboxGroup","9jC2J"],["composeRenderProps","bA6Cz"]],"tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9PYFQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Check);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const Check = (0, _createLucideIconJsDefault.default)("check", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5Mlaw":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Minus);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ]
];
const Minus = (0, _createLucideIconJsDefault.default)("minus", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5fXWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "FieldError", ()=>FieldError);
parcelHelpers.export(exports, "fieldBorderStyles", ()=>fieldBorderStyles);
parcelHelpers.export(exports, "fieldGroupStyles", ()=>fieldGroupStyles);
parcelHelpers.export(exports, "FieldGroup", ()=>FieldGroup);
parcelHelpers.export(exports, "Input", ()=>Input);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
function Label(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Label), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('text-sm text-gray-600 dark:text-zinc-400 font-medium cursor-default w-fit', props.className)
    });
}
function Description(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...props,
        slot: "description",
        className: (0, _tailwindMerge.twMerge)('text-sm text-gray-600', props.className)
    });
}
function FieldError(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.FieldError), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'text-sm text-red-600 forced-colors:text-[Mark]')
    });
}
const fieldBorderStyles = (0, _tailwindVariants.tv)({
    variants: {
        isFocusWithin: {
            false: 'border-gray-300 dark:border-zinc-500 forced-colors:border-[ButtonBorder]',
            true: 'border-gray-600 dark:border-zinc-300 forced-colors:border-[Highlight]'
        },
        isInvalid: {
            true: 'border-red-600 dark:border-red-600 forced-colors:border-[Mark]'
        },
        isDisabled: {
            true: 'border-gray-200 dark:border-zinc-700 forced-colors:border-[GrayText]'
        }
    }
});
const fieldGroupStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group flex items-center h-9 box-border bg-white dark:bg-zinc-900 forced-colors:bg-[Field] border-2 rounded-lg overflow-hidden',
    variants: fieldBorderStyles.variants
});
function FieldGroup(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Group), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>fieldGroupStyles({
                ...renderProps,
                className
            }))
    });
}
function Input(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Input), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'px-2 py-1.5 flex-1 min-w-0 border-0 outline outline-0 bg-white dark:bg-zinc-900 text-sm text-gray-800 dark:text-zinc-200 disabled:text-gray-200 dark:disabled:text-zinc-600')
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["composeRenderProps","bA6Cz"],["FieldError","algyu"],["Group","6UspO"],["Input","jU9y1"],["Label","fjKq6"],["Text","jt9fm"]],"tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7C0UI":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Funnel);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
            key: "sc7q7i"
        }
    ]
];
const Funnel = (0, _createLucideIconJsDefault.default)("funnel", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d6evu":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Plus);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const Plus = (0, _createLucideIconJsDefault.default)("plus", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2oAid":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>RefreshCw);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const RefreshCw = (0, _createLucideIconJsDefault.default)("refresh-cw", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3FWGC":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>SlidersVertical);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "line",
        {
            x1: "4",
            x2: "4",
            y1: "21",
            y2: "14",
            key: "1p332r"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "4",
            y1: "10",
            y2: "3",
            key: "gb41h5"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "21",
            y2: "12",
            key: "hf2csr"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "3",
            key: "1kfi7u"
        }
    ],
    [
        "line",
        {
            x1: "20",
            x2: "20",
            y1: "21",
            y2: "16",
            key: "1lhrwl"
        }
    ],
    [
        "line",
        {
            x1: "20",
            x2: "20",
            y1: "12",
            y2: "3",
            key: "16vvfq"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "6",
            y1: "14",
            y2: "14",
            key: "1uebub"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "14",
            y1: "8",
            y2: "8",
            key: "1yglbp"
        }
    ],
    [
        "line",
        {
            x1: "18",
            x2: "22",
            y1: "16",
            y2: "16",
            key: "1jxqpz"
        }
    ]
];
const SlidersVertical = (0, _createLucideIconJsDefault.default)("sliders-vertical", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iPFGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>Menu);
parcelHelpers.export(exports, "MenuItem", ()=>MenuItem);
parcelHelpers.export(exports, "MenuSeparator", ()=>MenuSeparator);
parcelHelpers.export(exports, "MenuSection", ()=>MenuSection);
parcelHelpers.export(exports, "MenuTrigger", ()=>MenuTrigger);
parcelHelpers.export(exports, "SubmenuTrigger", ()=>SubmenuTrigger);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _listBox = require("./ListBox");
var _popover = require("./Popover");
'use client';
function Menu(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Menu), {
        ...props,
        className: "font-sans p-1 outline outline-0 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)] empty:text-center empty:pb-2"
    });
}
function MenuItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.MenuItem), {
        textValue: textValue,
        ...props,
        className: (0, _listBox.dropdownItemStyles),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { selectionMode, isSelected, hasSubmenu })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    selectionMode !== 'none' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex items-center w-4",
                        children: isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex items-center flex-1 gap-2 font-normal truncate group-selected:font-semibold",
                        children: children
                    }),
                    hasSubmenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                        "aria-hidden": true,
                        className: "absolute w-4 h-4 right-2"
                    })
                ]
            }))
    });
}
function MenuSeparator(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Separator), {
        ...props,
        className: "mx-3 my-1 border-b border-gray-300 dark:border-zinc-700"
    });
}
function MenuSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.MenuSection), {
        ...props,
        className: "first:-mt-[5px] after:content-[''] after:block after:h-[5px]",
        children: [
            props.title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Header), {
                className: "text-sm font-semibold text-gray-500 dark:text-zinc-300 px-4 py-1 truncate sticky -top-[5px] -mt-px -mx-1 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 border-y border-y-gray-200 dark:border-y-zinc-700 [&+*]:mt-1",
                children: props.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: props.items,
                children: props.children
            })
        ]
    });
}
function MenuTrigger(props) {
    let [trigger, menu] = (0, _reactDefault.default).Children.toArray(props.children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.MenuTrigger), {
        ...props,
        children: [
            trigger,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                placement: props.placement,
                className: "min-w-[150px]",
                children: menu
            })
        ]
    });
}
function SubmenuTrigger(props) {
    let [trigger, menu] = (0, _reactDefault.default).Children.toArray(props.children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.SubmenuTrigger), {
        ...props,
        children: [
            trigger,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                offset: -2,
                crossOffset: -4,
                children: menu
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["Check","9PYFQ","default"],["ChevronRight","elAlB","default"]],"react":"a1TxN","react-aria-components":[["Collection","2Jd0Q"],["composeRenderProps","bA6Cz"],["Header","kpwoY"],["Menu","8JFUP"],["MenuItem","8JFUP"],["MenuSection","8JFUP"],["MenuTrigger","8JFUP"],["SubmenuTrigger","8JFUP"],["Separator","8A8dQ"]],"./ListBox":"4YPUR","./Popover":"Dr9D3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"elAlB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const ChevronRight = (0, _createLucideIconJsDefault.default)("chevron-right", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4YPUR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBox", ()=>ListBox);
parcelHelpers.export(exports, "itemStyles", ()=>itemStyles);
parcelHelpers.export(exports, "ListBoxItem", ()=>ListBoxItem);
parcelHelpers.export(exports, "dropdownItemStyles", ()=>dropdownItemStyles);
parcelHelpers.export(exports, "DropdownItem", ()=>DropdownItem);
parcelHelpers.export(exports, "DropdownSection", ()=>DropdownSection);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
function ListBox({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'outline-0 p-1 w-[200px] bg-white dark:bg-zinc-900 border border-gray-300 dark:border-zinc-600 rounded-lg font-sans'),
        children: children
    });
}
const itemStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group relative flex items-center gap-8 cursor-default select-none py-1.5 px-2.5 rounded-md will-change-transform text-sm forced-color-adjust-none',
    variants: {
        isSelected: {
            false: 'text-slate-700 dark:text-zinc-300 hover:bg-slate-200 dark:hover:bg-zinc-700 -outline-offset-2',
            true: 'bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] [&:has(+[data-selected])]:rounded-b-none [&+[data-selected]]:rounded-t-none -outline-offset-4 outline-white dark:outline-white forced-colors:outline-[HighlightText]'
        },
        isDisabled: {
            true: 'text-slate-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    }
});
function ListBoxItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        textValue: textValue,
        className: itemStyles,
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute left-4 right-4 bottom-0 h-px bg-white/20 forced-colors:bg-[HighlightText] hidden [.group[data-selected]:has(+[data-selected])_&]:block"
                    })
                ]
            }))
    });
}
const dropdownItemStyles = (0, _tailwindVariants.tv)({
    base: 'group flex items-center gap-4 cursor-default select-none py-2 pl-3 pr-1 rounded-lg outline outline-0 text-sm forced-color-adjust-none no-underline [&[href]]:cursor-pointer',
    variants: {
        isDisabled: {
            false: 'text-gray-900 dark:text-zinc-100',
            true: 'text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        },
        isFocused: {
            true: 'bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]'
        }
    },
    compoundVariants: [
        {
            isFocused: false,
            isOpen: true,
            className: 'bg-gray-100 dark:bg-zinc-700/60'
        }
    ]
});
function DropdownItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        textValue: textValue,
        className: dropdownItemStyles,
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isSelected })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex items-center flex-1 gap-2 font-normal truncate group-selected:font-semibold",
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "flex items-center w-5",
                        children: isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                            className: "w-4 h-4"
                        })
                    })
                ]
            }))
    });
}
function DropdownSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBoxSection), {
        className: "first:-mt-[5px] after:content-[''] after:block after:h-[5px] last:after:hidden",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Header), {
                className: "text-sm font-semibold text-gray-500 dark:text-zinc-300 px-4 py-1 truncate sticky -top-[5px] -mt-px -mx-1 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 border-y border-y-gray-200 dark:border-y-zinc-700 [&+*]:mt-1",
                children: props.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: props.items,
                children: props.children
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["Check","9PYFQ","default"]],"react":"a1TxN","react-aria-components":[["Collection","2Jd0Q"],["composeRenderProps","bA6Cz"],["Header","kpwoY"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["ListBoxSection","dNdIK"]],"tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Dr9D3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tailwindVariants = require("tailwind-variants");
'use client';
const styles = (0, _tailwindVariants.tv)({
    base: 'font-sans bg-white dark:bg-zinc-900/70 dark:backdrop-blur-2xl dark:backdrop-saturate-200 forced-colors:bg-[Canvas] shadow-2xl rounded-xl bg-clip-padding border border-black/10 dark:border-white/[15%] text-slate-700 dark:text-zinc-300 outline-0',
    variants: {
        isEntering: {
            true: 'animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1 ease-out duration-200'
        },
        isExiting: {
            true: 'animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 placement-left:slide-out-to-right-1 placement-right:slide-out-to-left-1 ease-in duration-150'
        }
    }
});
function Popover({ children, showArrow, className, ...props }) {
    let offset = showArrow ? 12 : 8;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Popover), {
        offset: offset,
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(className, (className, renderProps)=>styles({
                ...renderProps,
                className
            })),
        children: [
            showArrow && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                className: "group",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: 12,
                    height: 12,
                    viewBox: "0 0 12 12",
                    className: "block fill-white dark:fill-[#1f1f21] forced-colors:fill-[Canvas] stroke-1 stroke-black/10 dark:stroke-zinc-600 forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0 0 L6 6 L12 0"
                    })
                })
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["OverlayArrow","kMtnS"],["Popover","l4JC0"]],"react":"a1TxN","tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2GPV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Modal", ()=>Modal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
'use client';
const overlayStyles = (0, _tailwindVariants.tv)({
    base: 'absolute top-0 left-0 w-full h-(--page-height) isolate z-20 bg-black/[50%] text-center backdrop-blur-lg',
    variants: {
        isEntering: {
            true: 'animate-in fade-in duration-200 ease-out'
        },
        isExiting: {
            true: 'animate-out fade-out duration-200 ease-in'
        }
    }
});
const modalStyles = (0, _tailwindVariants.tv)({
    base: 'font-sans w-full max-w-[min(90vw,450px)] max-h-[calc(var(--visual-viewport-height)*.9)] rounded-2xl bg-white dark:bg-zinc-800/70 dark:backdrop-blur-2xl dark:backdrop-saturate-200 forced-colors:bg-[Canvas] text-left align-middle text-slate-700 dark:text-zinc-300 shadow-2xl bg-clip-padding border border-black/10 dark:border-white/10',
    variants: {
        isEntering: {
            true: 'animate-in zoom-in-105 ease-out duration-200'
        },
        isExiting: {
            true: 'animate-out zoom-out-95 ease-in duration-200'
        }
    }
});
function Modal(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ModalOverlay), {
        ...props,
        className: overlayStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "sticky top-0 left-0 w-full h-(--visual-viewport-height) flex items-center justify-center box-border",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Modal), {
                ...props,
                className: modalStyles
            })
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"29rOq","tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2Wr3I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _agapanthusJpg = require("url:./plants/agapanthus.jpg");
var _agapanthusJpgDefault = parcelHelpers.interopDefault(_agapanthusJpg);
var _aloeJpg = require("url:./plants/aloe.jpg");
var _aloeJpgDefault = parcelHelpers.interopDefault(_aloeJpg);
var _dracaenaJpg = require("url:./plants/dracaena.jpg");
var _dracaenaJpgDefault = parcelHelpers.interopDefault(_dracaenaJpg);
var _fernJpg = require("url:./plants/fern.jpg");
var _fernJpgDefault = parcelHelpers.interopDefault(_fernJpg);
var _figJpg = require("url:./plants/fig.jpg");
var _figJpgDefault = parcelHelpers.interopDefault(_figJpg);
var _gardeniaJpg = require("url:./plants/gardenia.jpg");
var _gardeniaJpgDefault = parcelHelpers.interopDefault(_gardeniaJpg);
var _ivyJpg = require("url:./plants/ivy.jpg");
var _ivyJpgDefault = parcelHelpers.interopDefault(_ivyJpg);
var _jacarandaJpg = require("url:./plants/jacaranda.jpg");
var _jacarandaJpgDefault = parcelHelpers.interopDefault(_jacarandaJpg);
var _maidenhairJpg = require("url:./plants/maidenhair.jpg");
var _maidenhairJpgDefault = parcelHelpers.interopDefault(_maidenhairJpg);
var _moneyJpg = require("url:./plants/money.jpg");
var _moneyJpgDefault = parcelHelpers.interopDefault(_moneyJpg);
var _monsteraJpg = require("url:./plants/monstera.jpg");
var _monsteraJpgDefault = parcelHelpers.interopDefault(_monsteraJpg);
var _morningJpg = require("url:./plants/morning.jpg");
var _morningJpgDefault = parcelHelpers.interopDefault(_morningJpg);
var _nasturtiumJpg = require("url:./plants/nasturtium.jpg");
var _nasturtiumJpgDefault = parcelHelpers.interopDefault(_nasturtiumJpg);
var _oleanderJpg = require("url:./plants/oleander.jpg");
var _oleanderJpgDefault = parcelHelpers.interopDefault(_oleanderJpg);
var _poplarJpg = require("url:./plants/poplar.jpg");
var _poplarJpgDefault = parcelHelpers.interopDefault(_poplarJpg);
var _spiderJpg = require("url:./plants/spider.jpg");
var _spiderJpgDefault = parcelHelpers.interopDefault(_spiderJpg);
var _starJpg = require("url:./plants/star.jpg");
var _starJpgDefault = parcelHelpers.interopDefault(_starJpg);
var _treeFernJpg = require("url:./plants/tree_fern.jpg");
var _treeFernJpgDefault = parcelHelpers.interopDefault(_treeFernJpg);
var _xmasJpg = require("url:./plants/xmas.jpg");
var _xmasJpgDefault = parcelHelpers.interopDefault(_xmasJpg);
var _zzJpg = require("url:./plants/zz.jpg");
var _zzJpgDefault = parcelHelpers.interopDefault(_zzJpg);
exports.default = [
    {
        id: 1,
        common_name: 'Aloe',
        scientific_name: [
            'Aloe vera'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _aloeJpgDefault.default)
        }
    },
    {
        id: 2,
        common_name: 'Blue Jacaranda',
        scientific_name: [
            'Jacaranda mimosifolia'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _jacarandaJpgDefault.default)
        }
    },
    {
        id: 3,
        common_name: 'Oleander',
        scientific_name: [
            'Nerium oleander'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _oleanderJpgDefault.default)
        }
    },
    {
        id: 4,
        common_name: 'Poplar',
        scientific_name: [
            'Populus'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _poplarJpgDefault.default)
        }
    },
    {
        id: 5,
        common_name: 'Zanzibar Gem',
        scientific_name: [
            'Zamioculcas'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _zzJpgDefault.default)
        }
    },
    {
        id: 6,
        common_name: 'Morning Glory',
        scientific_name: [
            'Ipomoea'
        ],
        watering: 'Frequent',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _morningJpgDefault.default)
        }
    },
    {
        id: 7,
        common_name: 'Christmas Bush',
        scientific_name: [
            'Ceratopetalum gummiferum'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _xmasJpgDefault.default)
        }
    },
    {
        id: 8,
        common_name: 'Gardenia',
        scientific_name: [
            'Gardenia jasminoides'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _gardeniaJpgDefault.default)
        }
    },
    {
        id: 9,
        common_name: 'Spider Plant',
        scientific_name: [
            'Chlorophytum comosum'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _spiderJpgDefault.default)
        }
    },
    {
        id: 10,
        common_name: 'Chinese Money Plant',
        scientific_name: [
            'Pilea peperomioides'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _moneyJpgDefault.default)
        }
    },
    {
        id: 11,
        common_name: 'Fiddle Leaf Fig',
        scientific_name: [
            'Ficus lyrata'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _figJpgDefault.default)
        }
    },
    {
        id: 12,
        common_name: 'Tuberous Sword Fern',
        scientific_name: [
            'Nephrolepis cordifolia'
        ],
        watering: 'Frequent',
        sunlight: [
            'part shade'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _fernJpgDefault.default)
        }
    },
    {
        id: 13,
        common_name: 'Star Jasmine',
        scientific_name: [
            'Trachelospermum jasminoides'
        ],
        watering: 'Frequent',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _starJpgDefault.default)
        }
    },
    {
        id: 14,
        common_name: 'Split-leaf Philodendron',
        scientific_name: [
            'Monstera deliciosa'
        ],
        watering: 'Frequent',
        sunlight: [
            'part shade'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _monsteraJpgDefault.default)
        }
    },
    {
        id: 15,
        common_name: 'Agapanthus',
        scientific_name: [
            'Agapanthus praecox'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _agapanthusJpgDefault.default)
        }
    },
    {
        id: 16,
        common_name: 'Tree Fern',
        scientific_name: [
            'Cyatheaceae'
        ],
        watering: 'Frequent',
        sunlight: [
            'part sun'
        ],
        cycle: 'Annual',
        default_image: {
            thumbnail: (0, _treeFernJpgDefault.default)
        }
    },
    {
        id: 17,
        common_name: 'Striped Dracaena',
        scientific_name: [
            'Asparagaceae'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _dracaenaJpgDefault.default)
        }
    },
    {
        id: 18,
        common_name: 'Delta Maidenhair Fern',
        scientific_name: [
            'Adiantum raddianum'
        ],
        watering: 'Average',
        sunlight: [
            'part shade'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _maidenhairJpgDefault.default)
        }
    },
    {
        id: 19,
        common_name: 'Ivy',
        scientific_name: [
            'Hedera'
        ],
        watering: 'Frequent',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _ivyJpgDefault.default)
        }
    },
    {
        id: 20,
        common_name: 'Nasturtium',
        scientific_name: [
            'Tropaeolum'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Annual',
        default_image: {
            thumbnail: (0, _nasturtiumJpgDefault.default)
        }
    }
];

},{"url:./plants/agapanthus.jpg":"9YfkL","url:./plants/aloe.jpg":"99nMi","url:./plants/dracaena.jpg":"5ntJ6","url:./plants/fern.jpg":"9G1Yy","url:./plants/fig.jpg":"1ts1t","url:./plants/gardenia.jpg":"8p6ES","url:./plants/ivy.jpg":"WhBxT","url:./plants/jacaranda.jpg":"39NTq","url:./plants/maidenhair.jpg":"4BDiK","url:./plants/money.jpg":"bQtEi","url:./plants/monstera.jpg":"kzslC","url:./plants/morning.jpg":"1Y9uq","url:./plants/nasturtium.jpg":"cy1Tn","url:./plants/oleander.jpg":"8EUfG","url:./plants/poplar.jpg":"7dncL","url:./plants/spider.jpg":"3zhbA","url:./plants/star.jpg":"duES8","url:./plants/tree_fern.jpg":"7gwLw","url:./plants/xmas.jpg":"iUx62","url:./plants/zz.jpg":"2OnO0","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9YfkL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("23T9U");

},{}],"99nMi":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("7DhUR");

},{}],"5ntJ6":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("13AxL");

},{}],"9G1Yy":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kOjWr");

},{}],"1ts1t":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("17tYV");

},{}],"8p6ES":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("7wu64");

},{}],"WhBxT":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8H5Vj");

},{}],"39NTq":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("evP0U");

},{}],"4BDiK":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("cwkB5");

},{}],"bQtEi":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3YajE");

},{}],"kzslC":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("XZ4On");

},{}],"1Y9uq":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("OIxRS");

},{}],"cy1Tn":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3cgqa");

},{}],"8EUfG":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("d6Xjf");

},{}],"7dncL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kpwkm");

},{}],"3zhbA":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8jlPY");

},{}],"duES8":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3zoab");

},{}],"7gwLw":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("2THLY");

},{}],"iUx62":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("9ssN2");

},{}],"2OnO0":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("4XdAR");

},{}],"f0WdN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _field = require("./Field");
var _utils = require("./utils");
var _fieldButton = require("./FieldButton");
'use client';
function SearchField({ label, description, errorMessage, placeholder, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.SearchField), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 min-w-[40px] font-sans'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.SearchIcon), {
                        "aria-hidden": true,
                        className: "w-4 h-4 ml-2 text-gray-500 dark:text-zinc-400 forced-colors:text-[ButtonText] group-disabled:text-gray-200 dark:group-disabled:text-zinc-600 forced-colors:group-disabled:text-[GrayText]"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                        placeholder: placeholder,
                        className: "[&::-webkit-search-cancel-button]:hidden"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldButton.FieldButton), {
                        className: "mr-1 w-6 group-empty:invisible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XIcon), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["SearchIcon","8cmET","default"],["XIcon","1gkBb","default"]],"react":"a1TxN","react-aria-components":"Uk5yj","./Field":"5fXWs","./utils":"jNXji","./FieldButton":"9xJpc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8cmET":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Search);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const Search = (0, _createLucideIconJsDefault.default)("search", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1gkBb":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>X);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const X = (0, _createLucideIconJsDefault.default)("x", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Uk5yj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldContext", ()=>SearchFieldContext);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _collections = require("@react-aria/collections");
var _fieldError = require("./FieldError");
var _rspcontexts = require("./RSPContexts");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
var _text = require("./Text");
const SearchFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SearchField = /*#__PURE__*/ (0, _collections.createHideableComponent)(function SearchField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SearchFieldContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, _react.useRef)(null);
    [props, inputRef] = (0, _utils.useContextProps)(props, inputRef, (0, _rspcontexts.FieldInputContext));
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let state = (0, _reactStately.useSearchFieldState)({
        ...props,
        validationBehavior
    });
    let { labelProps, inputProps, clearButtonProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useSearchField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior
    }, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isEmpty: state.value === '',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false,
            state
        },
        defaultClassName: 'react-aria-SearchField'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.value === '' || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _button.ButtonContext),
                clearButtonProps
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
});

},{"react-aria":"2czfR","./Button":"9G5XO","./utils":"bA6Cz","@react-aria/collections":"jY1vZ","./FieldError":"algyu","./RSPContexts":"lIerG","@react-aria/utils":"3upVm","./Form":"g7RKA","./Group":"6UspO","./Input":"jU9y1","./Label":"fjKq6","react":"a1TxN","react-stately":"fG7Zj","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2czfR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a search field.
 * @param props - Props for the search field.
 * @param state - State for the search field, as returned by `useSearchFieldState`.
 * @param inputRef - A ref to the input element.
 */ parcelHelpers.export(exports, "useSearchField", ()=>useSearchField);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _textfield = require("@react-aria/textfield");
function useSearchField(props, state, inputRef) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/searchfield');
    let { isDisabled, isReadOnly, onSubmit, onClear, type = 'search' } = props;
    let onKeyDown = (e)=>{
        const key = e.key;
        if (key === 'Enter' && (isDisabled || isReadOnly)) e.preventDefault();
        if (isDisabled || isReadOnly) return;
        // for backward compatibility;
        // otherwise, "Enter" on an input would trigger a form submit, the default browser behavior
        if (key === 'Enter' && onSubmit) {
            e.preventDefault();
            onSubmit(state.value);
        }
        if (key === 'Escape') {
            // Also check the inputRef value for the case where the value was set directly on the input element instead of going through
            // the hook
            if (state.value === '' && (!inputRef.current || inputRef.current.value === '')) e.continuePropagation();
            else {
                e.preventDefault();
                state.setValue('');
                if (onClear) onClear();
            }
        }
    };
    let onClearButtonClick = ()=>{
        state.setValue('');
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        inputRef.current?.focus();
    };
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _textfield.useTextField)({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: !isReadOnly ? (0, _utils.chain)(onKeyDown, props.onKeyDown) : props.onKeyDown,
        type
    }, inputRef);
    return {
        labelProps,
        inputProps: {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        },
        clearButtonProps: {
            'aria-label': stringFormatter.format('Clear search'),
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart
        },
        descriptionProps,
        errorMessageProps,
        ...validation
    };
}

},{"@react-aria/utils":"ij7eS","../intl/*.json":"9Ekzk","@react-aria/i18n":"7lxyl","@react-aria/textfield":"j6sGd","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Ekzk":[function(require,module,exports,__globalThis) {
const _temp0 = require("ecfc0164cdafbc11");
const _temp1 = require("533820a702a6cc4d");
const _temp2 = require("adc1d07960abb370");
const _temp3 = require("959d90d2e1b8754d");
const _temp4 = require("c7bcb7c68ae4d133");
const _temp5 = require("7592b3baca1e1ab7");
const _temp6 = require("377509ed67276db9");
const _temp7 = require("bcdffd9a74290826");
const _temp8 = require("66f96fbb9c6f57b3");
const _temp9 = require("96660d96c61006f6");
const _temp10 = require("e42562491f0a003a");
const _temp11 = require("b2e319db05a47686");
const _temp12 = require("8c2f9a8959ebc6d8");
const _temp13 = require("5d3c12b049cdb778");
const _temp14 = require("11cc1fb3d7f8c195");
const _temp15 = require("c7097d1ca0fc0d82");
const _temp16 = require("6a0de05d519cdbf5");
const _temp17 = require("9741ebd533b2078c");
const _temp18 = require("406b77d2f3fc3437");
const _temp19 = require("53d9d9bd8feb82b1");
const _temp20 = require("7b20791f74309e10");
const _temp21 = require("d06b6fc5dda02e88");
const _temp22 = require("a28a6945ed983bd6");
const _temp23 = require("ebef8b25fee90b36");
const _temp24 = require("84e709af2309f7d7");
const _temp25 = require("2526519e9c0d0e8b");
const _temp26 = require("441fee45de55b70c");
const _temp27 = require("190818b45cb371e");
const _temp28 = require("929004f2e45d5643");
const _temp29 = require("77e5fd88fe39459e");
const _temp30 = require("bbe929569218677b");
const _temp31 = require("d3b3389f28451bb4");
const _temp32 = require("6b83a28d69d9848f");
const _temp33 = require("7fb75107a926411e");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"ecfc0164cdafbc11":"dEiWw","533820a702a6cc4d":"gFCWI","adc1d07960abb370":"5nyKo","959d90d2e1b8754d":"f45p8","c7bcb7c68ae4d133":"8K1zg","7592b3baca1e1ab7":"1mLLx","377509ed67276db9":"dIYmL","bcdffd9a74290826":"6jDsu","66f96fbb9c6f57b3":"cur6C","96660d96c61006f6":"4eADM","e42562491f0a003a":"bi0G6","b2e319db05a47686":"dVrnP","8c2f9a8959ebc6d8":"5ko3W","5d3c12b049cdb778":"fy2Wi","11cc1fb3d7f8c195":"lTHNp","c7097d1ca0fc0d82":"hYI7g","6a0de05d519cdbf5":"21bHw","9741ebd533b2078c":"esHUJ","406b77d2f3fc3437":"6H1ok","53d9d9bd8feb82b1":"jQz8I","7b20791f74309e10":"9tUMB","d06b6fc5dda02e88":"2eHgi","a28a6945ed983bd6":"gKiZ7","ebef8b25fee90b36":"1KGPC","84e709af2309f7d7":"8fT4G","2526519e9c0d0e8b":"3mBvJ","441fee45de55b70c":"aaDmD","190818b45cb371e":"fNATE","929004f2e45d5643":"kmzjU","77e5fd88fe39459e":"aSLoa","bbe929569218677b":"8Q37f","d3b3389f28451bb4":"5mfWM","6b83a28d69d9848f":"3FfqQ","7fb75107a926411e":"38NZI"}],"dEiWw":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{645}\u{633}\u{62D} \u{627}\u{644}\u{628}\u{62D}\u{62B}`
};

},{}],"gFCWI":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{442}\u{44A}\u{440}\u{441}\u{435}\u{43D}\u{435}`
};

},{}],"5nyKo":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Vymazat hled\xe1n\xed`
};

},{}],"f45p8":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Ryd s\xf8gning`
};

},{}],"8K1zg":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Suche zur\xfccksetzen`
};

},{}],"1mLLx":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{391}\u{3C0}\u{3B1}\u{3BB}\u{3BF}\u{3B9}\u{3C6}\u{3AE} \u{3B1}\u{3BD}\u{3B1}\u{3B6}\u{3AE}\u{3C4}\u{3B7}\u{3C3}\u{3B7}\u{3C2}`
};

},{}],"dIYmL":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Clear search`
};

},{}],"6jDsu":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Borrar b\xfasqueda`
};

},{}],"cur6C":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `T\xfchjenda otsing`
};

},{}],"4eADM":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Tyhjenn\xe4 haku`
};

},{}],"bi0G6":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Effacer la recherche`
};

},{}],"dVrnP":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{5E0}\u{5E7}\u{5D4} \u{5D7}\u{5D9}\u{5E4}\u{5D5}\u{5E9}`
};

},{}],"5ko3W":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Obri\u{161}i pretragu`
};

},{}],"fy2Wi":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Keres\xe9s t\xf6rl\xe9se`
};

},{}],"lTHNp":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Cancella ricerca`
};

},{}],"hYI7g":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{691C}\u{7D22}\u{3092}\u{30AF}\u{30EA}\u{30A2}`
};

},{}],"21bHw":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{AC80}\u{C0C9} \u{C9C0}\u{C6B0}\u{AE30}`
};

},{}],"esHUJ":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `I\u{161}valyti ie\u{161}k\u{105}`
};

},{}],"6H1ok":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Not\u{12B}r\u{12B}t mekl\u{113}\u{161}anu`
};

},{}],"jQz8I":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `T\xf8m s\xf8k`
};

},{}],"9tUMB":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Zoekactie wissen`
};

},{}],"2eHgi":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Wyczy\u{15B}\u{107} zawarto\u{15B}\u{107} wyszukiwania`
};

},{}],"gKiZ7":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Limpar pesquisa`
};

},{}],"1KGPC":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Limpar pesquisa`
};

},{}],"8fT4G":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{15E}terge\u{163}i c\u{103}utarea`
};

},{}],"3mBvJ":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{438}\u{441}\u{43A}`
};

},{}],"aaDmD":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Vymaza\u{165} vyh\u{13E}ad\xe1vanie`
};

},{}],"fNATE":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Po\u{10D}isti iskanje`
};

},{}],"kmzjU":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Obri\u{161}i pretragu`
};

},{}],"aSLoa":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Rensa s\xf6kning`
};

},{}],"8Q37f":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Aramay\u{131} temizle`
};

},{}],"5mfWM":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43F}\u{43E}\u{448}\u{443}\u{43A}`
};

},{}],"3FfqQ":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{7D22}`
};

},{}],"38NZI":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{5C0B}\u{689D}\u{4EF6}`
};

},{}],"fG7Zj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a search field.
 */ parcelHelpers.export(exports, "useSearchFieldState", ()=>useSearchFieldState);
var _utils = require("@react-stately/utils");
function useSearchFieldState(props) {
    let [value, setValue] = (0, _utils.useControlledState)(toString(props.value), toString(props.defaultValue) || '', props.onChange);
    return {
        value,
        setValue
    };
}
function toString(val) {
    if (val == null) return;
    return val.toString();
}

},{"@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9xJpc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldButton", ()=>FieldButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
let button = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'relative inline-flex items-center border-0 font-sans text-sm text-center transition rounded-lg cursor-default p-1 flex items-center justify-center text-gray-600 bg-transparent hover:bg-black/[5%] pressed:bg-black/10 dark:text-zinc-400 dark:hover:bg-white/10 dark:pressed:bg-white/20 disabled:bg-transparent',
    variants: {
        isDisabled: {
            true: 'bg-gray-100 dark:bg-zinc-800 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText] border-black/5 dark:border-white/5'
        }
    }
});
function FieldButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>button({
                ...renderProps,
                className
            })),
        children: props.children
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"]],"tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9wXZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroup", ()=>TagGroup);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
const colors = {
    gray: 'bg-white text-gray-600 border-gray-200 hover:border-gray-300 dark:bg-zinc-900 dark:text-zinc-300 dark:border-zinc-600 dark:hover:border-zinc-500',
    green: 'bg-green-100 text-green-700 border-green-200 hover:border-green-300 dark:bg-green-300/20 dark:text-green-400 dark:border-green-300/10 dark:hover:border-green-300/20',
    yellow: 'bg-yellow-100 text-yellow-700 border-yellow-200 hover:border-yellow-300 dark:bg-yellow-300/20 dark:text-yellow-400 dark:border-yellow-300/10 dark:hover:border-yellow-300/20',
    blue: 'bg-blue-100 text-blue-700 border-blue-200 hover:border-blue-300 dark:bg-blue-400/20 dark:text-blue-300 dark:border-blue-400/10 dark:hover:border-blue-400/20'
};
const ColorContext = /*#__PURE__*/ (0, _react.createContext)('gray');
const tagStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'transition cursor-default text-xs rounded-full border px-3 py-0.5 flex items-center max-w-fit gap-1 font-sans',
    variants: {
        color: {
            gray: '',
            green: '',
            yellow: '',
            blue: ''
        },
        allowsRemoving: {
            true: 'pr-1'
        },
        isSelected: {
            true: 'bg-blue-600 text-white border-transparent forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] forced-color-adjust-none'
        },
        isDisabled: {
            true: 'bg-gray-100 dark:bg-transparent dark:border-white/20 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    },
    compoundVariants: Object.keys(colors).map((color)=>({
            isSelected: false,
            isDisabled: false,
            color,
            class: colors[color]
        }))
});
function TagGroup({ label, description, errorMessage, items, children, renderEmptyState, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TagGroup), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('flex flex-col gap-2 font-sans', props.className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorContext.Provider, {
                value: props.color || 'gray',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TagList), {
                    items: items,
                    renderEmptyState: renderEmptyState,
                    className: "flex flex-wrap gap-1",
                    children: children
                })
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                slot: "errorMessage",
                className: "text-sm text-red-600",
                children: errorMessage
            })
        ]
    });
}
const removeButtonStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'cursor-default rounded-full transition-[background-color] p-0.5 flex items-center justify-center hover:bg-black/10 dark:hover:bg-white/10 pressed:bg-black/20 dark:pressed:bg-white/20'
});
function Tag({ children, color, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    let groupColor = (0, _react.useContext)(ColorContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tag), {
        textValue: textValue,
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>tagStyles({
                ...renderProps,
                className,
                color: color || groupColor
            })),
        children: (0, _reactAriaComponents.composeRenderProps)(children, (children, { allowsRemoving })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    allowsRemoving && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "remove",
                        className: removeButtonStyles,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XIcon), {
                            "aria-hidden": true,
                            className: "w-3 h-3"
                        })
                    })
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["XIcon","1gkBb","default"]],"react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"],["Tag","dIN55"],["TagGroup","dIN55"],["TagList","dIN55"],["Text","jt9fm"]],"tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4lonv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
'use client';
const styles = (0, _tailwindVariants.tv)({
    base: 'group bg-slate-700 dark:bg-slate-600 border border-slate-800 dark:border-white/10 shadow-[inset_0_1px_0_0_var(--color-gray-600)] dark:shadow-none font-sans text-white text-sm rounded-lg drop-shadow-lg will-change-transform px-3 py-1 box-border',
    variants: {
        isEntering: {
            true: 'animate-in fade-in placement-bottom:slide-in-from-top-0.5 placement-top:slide-in-from-bottom-0.5 placement-left:slide-in-from-right-0.5 placement-right:slide-in-from-left-0.5 ease-out duration-200'
        },
        isExiting: {
            true: 'animate-out fade-out placement-bottom:slide-out-to-top-0.5 placement-top:slide-out-to-bottom-0.5 placement-left:slide-out-to-right-0.5 placement-right:slide-out-to-left-0.5 ease-in duration-150'
        }
    }
});
function Tooltip({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Tooltip), {
        ...props,
        offset: 10,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>styles({
                ...renderProps,
                className
            })),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: 8,
                    height: 8,
                    viewBox: "0 0 8 8",
                    className: "block fill-slate-700 dark:fill-slate-600 forced-colors:fill-[Canvas] stroke-gray-800 dark:stroke-white/10 forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0 0 L4 4 L8 0"
                    })
                })
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["composeRenderProps","bA6Cz"],["OverlayArrow","kMtnS"],["Tooltip","fLMVd"]],"tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5mUiz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cycleIcon", ()=>cycleIcon);
parcelHelpers.export(exports, "CycleLabel", ()=>CycleLabel);
parcelHelpers.export(exports, "sunIcons", ()=>sunIcons);
parcelHelpers.export(exports, "sunColors", ()=>sunColors);
parcelHelpers.export(exports, "SunLabel", ()=>SunLabel);
parcelHelpers.export(exports, "getSunlight", ()=>getSunlight);
parcelHelpers.export(exports, "wateringIcons", ()=>wateringIcons);
parcelHelpers.export(exports, "WateringLabel", ()=>WateringLabel);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
const labelStyles = {
    gray: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-zinc-700 dark:text-zinc-300 dark:border-zinc-600',
    green: 'bg-green-100 text-green-700 border-green-200 dark:bg-green-300/20 dark:text-green-400 dark:border-green-300/10',
    yellow: 'bg-yellow-100 text-yellow-700 border-yellow-200 dark:bg-yellow-300/20 dark:text-yellow-400 dark:border-yellow-300/10',
    blue: 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-400/20 dark:text-blue-300 dark:border-blue-400/10'
};
function Label({ color, icon, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: `${labelStyles[color]} text-xs rounded-full border px-2 flex items-center max-w-fit gap-1`,
        children: [
            icon,
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "truncate capitalize",
                children: children
            })
        ]
    });
}
const cycleIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
    "aria-hidden": "true",
    className: "w-4 h-4 shrink-0"
});
function CycleLabel({ cycle }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
        color: "green",
        icon: cycleIcon,
        children: cycle
    });
}
const sunIcons = {
    'full sun': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Sun), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    }),
    'part sun': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.SunDim), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    }),
    'part shade': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CloudSun), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    })
};
const sunColors = {
    'full sun': 'yellow',
    'part sun': 'yellow',
    'part shade': 'gray'
};
function SunLabel({ sun }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
        color: sunColors[sun],
        icon: sunIcons[sun],
        children: sun
    });
}
function getSunlight(item) {
    return (item.sunlight.find((s)=>s.startsWith('part')) || item.sunlight[0]).split('/')[0];
}
const wateringIcons = {
    'Frequent': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Droplets), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    }),
    'Average': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Droplet), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    }),
    'Minimum': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Dessert), {
        "aria-hidden": "true",
        className: "w-4 h-4 shrink-0"
    })
};
const wateringColors = {
    'Frequent': 'blue',
    'Average': 'blue',
    'Minimum': 'gray'
};
function WateringLabel({ watering }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
        color: wateringColors[watering],
        icon: wateringIcons[watering],
        children: watering
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["CloudSun","e905L","default"],["Dessert","dMqjU","default"],["Droplet","csbic","default"],["Droplets","itGFz","default"],["RefreshCw","2oAid","default"],["Sun","7xMzH","default"],["SunDim","KyXkF","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e905L":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CloudSun);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ],
    [
        "path",
        {
            d: "M15.947 12.65a4 4 0 0 0-5.925-4.128",
            key: "dpwdj0"
        }
    ],
    [
        "path",
        {
            d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z",
            key: "s09mg5"
        }
    ]
];
const CloudSun = (0, _createLucideIconJsDefault.default)("cloud-sun", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dMqjU":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Dessert);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "4",
            r: "2",
            key: "muu5ef"
        }
    ],
    [
        "path",
        {
            d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
            key: "lfo06j"
        }
    ],
    [
        "path",
        {
            d: "M3.2 14.8a9 9 0 0 0 17.6 0",
            key: "12xarc"
        }
    ]
];
const Dessert = (0, _createLucideIconJsDefault.default)("dessert", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"csbic":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Droplet);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
            key: "c7niix"
        }
    ]
];
const Droplet = (0, _createLucideIconJsDefault.default)("droplet", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"itGFz":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Droplets);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
            key: "1ptgy4"
        }
    ],
    [
        "path",
        {
            d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
            key: "1sl1rz"
        }
    ]
];
const Droplets = (0, _createLucideIconJsDefault.default)("droplets", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7xMzH":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Sun);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "m17.66 17.66 1.41 1.41",
            key: "ptbguv"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m6.34 17.66-1.41 1.41",
            key: "1m8zz5"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ]
];
const Sun = (0, _createLucideIconJsDefault.default)("sun", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"KyXkF":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>SunDim);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 4h.01",
            key: "1ujb9j"
        }
    ],
    [
        "path",
        {
            d: "M20 12h.01",
            key: "1ykeid"
        }
    ],
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M4 12h.01",
            key: "158zrr"
        }
    ],
    [
        "path",
        {
            d: "M17.657 6.343h.01",
            key: "31pqzk"
        }
    ],
    [
        "path",
        {
            d: "M17.657 17.657h.01",
            key: "jehnf4"
        }
    ],
    [
        "path",
        {
            d: "M6.343 17.657h.01",
            key: "gdk6ow"
        }
    ],
    [
        "path",
        {
            d: "M6.343 6.343h.01",
            key: "1uurf0"
        }
    ]
];
const SunDim = (0, _createLucideIconJsDefault.default)("sun-dim", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5iWC0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlantTable", ()=>PlantTable);
var _jsxRuntime = require("react/jsx-runtime");
var _table = require("tailwind-starter/Table");
var _lucideReact = require("lucide-react");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("tailwind-starter/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tailwindVariants = require("tailwind-variants");
var _labels = require("./Labels");
var _plantActionMenu = require("./PlantActionMenu");
const allColumns = [
    {
        id: 'favorite',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.VisuallyHidden), {
            children: "Favorite"
        }),
        width: 40,
        minWidth: 40
    },
    {
        id: 'common_name',
        children: 'Name',
        minWidth: 150,
        allowsSorting: true
    },
    {
        id: 'cycle',
        children: 'Cycle',
        defaultWidth: 120,
        allowsSorting: true
    },
    {
        id: 'sunlight',
        children: 'Sunlight',
        defaultWidth: 120,
        allowsSorting: true
    },
    {
        id: 'watering',
        children: 'Watering',
        defaultWidth: 120,
        allowsSorting: true
    },
    {
        id: 'actions',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.VisuallyHidden), {
            children: "Actions"
        }),
        width: 64,
        minWidth: 64
    }
];
function PlantTable(props) {
    let { sortDescriptor, onSortChange, visibleColumns, items, onFavoriteChange, onEdit, onDelete } = props;
    let columns = (0, _react.useMemo)(()=>{
        let res = allColumns.filter((c)=>visibleColumns === 'all' || visibleColumns.has(c.id));
        res[1] = {
            ...res[1],
            isRowHeader: true
        };
        return res;
    }, [
        visibleColumns
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
        "aria-label": "My plants",
        selectionMode: "multiple",
        sortDescriptor: sortDescriptor,
        onSortChange: onSortChange,
        className: "h-[320px] hidden md:block",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                columns: columns,
                children: (column)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                        ...column
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                items: items,
                dependencies: [
                    columns
                ],
                renderEmptyState: ()=>'No results. Try changing the filters.',
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Row), {
                        columns: columns,
                        children: (column)=>{
                            switch(column.id){
                                case 'favorite':
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FavoriteButton, {
                                            isSelected: item.isFavorite,
                                            onChange: (v)=>onFavoriteChange(item.id, v)
                                        })
                                    });
                                case 'common_name':
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                        textValue: item.common_name,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "grid grid-cols-[40px_1fr] gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    alt: "",
                                                    src: item.default_image?.thumbnail,
                                                    className: "inline rounded-sm row-span-2 object-contain h-[40px] w-[40px]"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "truncate capitalize",
                                                    children: item.common_name
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "truncate text-xs text-gray-600 dark:text-zinc-400",
                                                    children: item.scientific_name
                                                })
                                            ]
                                        })
                                    });
                                case 'cycle':
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labels.CycleLabel), {
                                            cycle: item.cycle
                                        })
                                    });
                                case 'sunlight':
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labels.SunLabel), {
                                            sun: (0, _labels.getSunlight)(item)
                                        })
                                    });
                                case 'watering':
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labels.WateringLabel), {
                                            watering: item.watering
                                        })
                                    });
                                case 'actions':
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _plantActionMenu.PlantActionMenu), {
                                            item: item,
                                            onFavoriteChange: onFavoriteChange,
                                            onEdit: onEdit,
                                            onDelete: onDelete
                                        })
                                    });
                                default:
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
                            }
                        }
                    })
            })
        ]
    });
}
const favoriteButtonStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group cursor-default align-middle rounded-sm border-0 bg-transparent p-0',
    variants: {
        isSelected: {
            false: 'text-gray-500 dark:text-zinc-400 pressed:text-gray-600 dark:pressed:text-zinc-300',
            true: 'text-gray-700 dark:text-slate-300 pressed:text-gray-800 dark:pressed:text-slate-200'
        }
    }
});
function FavoriteButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButton), {
        "aria-label": "Favorite",
        ...props,
        className: favoriteButtonStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.StarIcon), {
            className: "w-5 h-5 fill-white dark:fill-zinc-900 group-selected:fill-current"
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/Table":"hjD4g","lucide-react":[["StarIcon","fJtT9","default"]],"react-aria-components":[["ToggleButton","98v4o"],["VisuallyHidden","7zrGr"]],"tailwind-starter/utils":"jNXji","react":"a1TxN","tailwind-variants":"dpXBU","./Labels":"5mUiz","./PlantActionMenu":"3MHuH","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hjD4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "Column", ()=>Column);
parcelHelpers.export(exports, "TableHeader", ()=>TableHeader);
parcelHelpers.export(exports, "TableBody", ()=>TableBody);
parcelHelpers.export(exports, "Row", ()=>Row);
parcelHelpers.export(exports, "Cell", ()=>Cell);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
var _checkbox = require("./Checkbox");
var _utils = require("./utils");
'use client';
function Table(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ResizableTableContainer), {
        onScroll: props.onScroll,
        className: (0, _tailwindMerge.twMerge)('w-full max-h-[320px] overflow-auto scroll-pt-[2.281rem] relative bg-white dark:bg-zinc-900 box-border border border-gray-300 dark:border-zinc-600 rounded-lg font-sans', props.className),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Table), {
            ...props,
            className: "border-separate border-spacing-0 box-border overflow-hidden has-[>[data-empty]]:h-full"
        })
    });
}
const columnStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'px-2 h-5 box-border flex-1 flex gap-1 items-center overflow-hidden'
});
const resizerStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'w-px px-[8px] translate-x-[8px] box-content py-1 h-5 bg-clip-content bg-gray-400 dark:bg-zinc-500 forced-colors:bg-[ButtonBorder] cursor-col-resize rounded-xs resizing:bg-blue-600 forced-colors:resizing:bg-[Highlight] resizing:w-[2px] resizing:pl-[7px] -outline-offset-2'
});
function Column(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'box-border h-1 [&:hover]:z-20 focus-within:z-20 text-start text-sm font-semibold text-gray-700 dark:text-zinc-300 cursor-default'),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { allowsSorting, sortDirection })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Group), {
                        role: "presentation",
                        tabIndex: -1,
                        className: columnStyles,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "truncate",
                                children: children
                            }),
                            allowsSorting && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: `w-4 h-4 flex items-center justify-center transition ${sortDirection === 'descending' ? 'rotate-180' : ''}`,
                                children: sortDirection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUp), {
                                    "aria-hidden": true,
                                    className: "w-4 h-4 text-gray-500 dark:text-zinc-400 forced-colors:text-[ButtonText]"
                                })
                            })
                        ]
                    }),
                    !props.width && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColumnResizer), {
                        className: resizerStyles
                    })
                ]
            }))
    });
}
function TableHeader(props) {
    let { selectionBehavior, selectionMode, allowsDragging } = (0, _reactAriaComponents.useTableOptions)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TableHeader), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'sticky top-0 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 dark:supports-[-moz-appearance:none]:bg-zinc-700 forced-colors:bg-[Canvas] rounded-t-lg border-b border-b-gray-200 dark:border-b-zinc-700'),
        children: [
            allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Column, {}),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                width: 36,
                minWidth: 36,
                className: "box-border p-2 text-sm font-semibold cursor-default text-start",
                children: selectionMode === 'multiple' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: props.columns,
                children: props.children
            })
        ]
    });
}
function TableBody(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableBody), {
        ...props,
        className: "empty:italic empty:text-center empty:text-sm"
    });
}
const rowStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group/row relative cursor-default select-none -outline-offset-2 text-gray-900 disabled:text-gray-300 dark:text-zinc-200 dark:disabled:text-zinc-600 text-sm hover:bg-gray-100 dark:hover:bg-zinc-700/60 selected:bg-blue-100 selected:hover:bg-blue-200 dark:selected:bg-blue-700/30 dark:selected:hover:bg-blue-700/40'
});
function Row({ id, columns, children, ...otherProps }) {
    let { selectionBehavior, allowsDragging } = (0, _reactAriaComponents.useTableOptions)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Row), {
        id: id,
        ...otherProps,
        className: rowStyles,
        children: [
            allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                    slot: "drag",
                    children: "\u2261"
                })
            }),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: columns,
                children: children
            })
        ]
    });
}
const cellStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'box-border border-b border-b-gray-200 dark:border-b-zinc-700 group-last/row:border-b-0 [--selected-border:var(--color-blue-200)] dark:[--selected-border:var(--color-blue-900)] group-selected/row:border-(--selected-border) in-[:has(+[data-selected])]:border-(--selected-border) p-2 truncate -outline-offset-2'
});
function Cell(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
        ...props,
        className: cellStyles
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ArrowUp","fi8VG","default"]],"react":"a1TxN","react-aria-components":[["Button","9G5XO"],["Cell","3vnUd"],["Column","3vnUd"],["ColumnResizer","3vnUd"],["ResizableTableContainer","3vnUd"],["Row","3vnUd"],["Table","3vnUd"],["TableBody","3vnUd"],["TableHeader","3vnUd"],["useTableOptions","3vnUd"],["Collection","2Jd0Q"],["composeRenderProps","bA6Cz"],["Group","6UspO"]],"tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","./Checkbox":"9J9Ug","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fi8VG":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ArrowUp);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
];
const ArrowUp = (0, _createLucideIconJsDefault.default)("arrow-up", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fJtT9":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Star);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
const Star = (0, _createLucideIconJsDefault.default)("star", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3MHuH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlantActionMenu", ()=>PlantActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("tailwind-starter/Button");
var _lucideReact = require("lucide-react");
var _menu = require("tailwind-starter/Menu");
function PlantActionMenu(props) {
    let { item, onFavoriteChange, onEdit, onDelete } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                "aria-label": "Actions",
                variant: "secondary",
                className: "row-span-2 place-self-center bg-transparent dark:bg-transparent border-transparent dark:border-transparent !p-1",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.MoreHorizontal), {
                    "aria-hidden": true,
                    className: "w-5 h-5"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                        id: "favorite",
                        onAction: ()=>onFavoriteChange(item.id, !item.isFavorite),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.StarIcon), {
                                "aria-hidden": true,
                                className: "w-4 h-4"
                            }),
                            " ",
                            item.isFavorite ? 'Unfavorite' : 'Favorite'
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                        id: "edit",
                        onAction: ()=>onEdit(item),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.PencilIcon), {
                                "aria-hidden": true,
                                className: "w-4 h-4"
                            }),
                            " Edit\u2026"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                        id: "delete",
                        onAction: ()=>onDelete(item),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.TrashIcon), {
                                "aria-hidden": true,
                                className: "w-4 h-4"
                            }),
                            " Delete\u2026"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.SubmenuTrigger), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                "aria-label": "Share",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ShareIcon), {
                                        "aria-hidden": true,
                                        className: "w-4 h-4"
                                    }),
                                    "Share"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                        href: `https://x.com/intent/tweet?text=${encodeURIComponent(item.common_name)}`,
                                        target: "blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": "X",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Twitter), {
                                                "aria-hidden": true,
                                                className: "w-4 h-4"
                                            }),
                                            " X\u2026"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
                                        href: `mailto:abc@example.com?subject=${encodeURIComponent(item.common_name)}`,
                                        target: "blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": "Email",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Mail), {
                                                "aria-hidden": true,
                                                className: "w-4 h-4"
                                            }),
                                            " Email\u2026"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/Button":"hk9LL","lucide-react":[["Mail","kzuAl","default"],["MoreHorizontal","9vbpj","default"],["PencilIcon","lKTtr","default"],["ShareIcon","g4buQ","default"],["StarIcon","fJtT9","default"],["TrashIcon","6PyBS","default"],["Twitter","jeVaH","default"]],"tailwind-starter/Menu":"iPFGc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kzuAl":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Mail);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
            key: "132q7q"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "4",
            width: "20",
            height: "16",
            rx: "2",
            key: "izxlao"
        }
    ]
];
const Mail = (0, _createLucideIconJsDefault.default)("mail", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9vbpj":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Ellipsis);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "12",
            r: "1",
            key: "1wjl8i"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "12",
            r: "1",
            key: "1pcz8c"
        }
    ]
];
const Ellipsis = (0, _createLucideIconJsDefault.default)("ellipsis", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lKTtr":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Pencil);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
];
const Pencil = (0, _createLucideIconJsDefault.default)("pencil", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g4buQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Share);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 2v13",
            key: "1km8f5"
        }
    ],
    [
        "path",
        {
            d: "m16 6-4-4-4 4",
            key: "13yo43"
        }
    ],
    [
        "path",
        {
            d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8",
            key: "1b2hhj"
        }
    ]
];
const Share = (0, _createLucideIconJsDefault.default)("share", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6PyBS":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Trash);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ]
];
const Trash = (0, _createLucideIconJsDefault.default)("trash", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jeVaH":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Twitter);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
            key: "pff0z6"
        }
    ]
];
const Twitter = (0, _createLucideIconJsDefault.default)("twitter", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bfd4s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlantDialog", ()=>PlantDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("tailwind-starter/Button");
var _reactAriaComponents = require("react-aria-components");
var _comboBox = require("tailwind-starter/ComboBox");
var _datePicker = require("tailwind-starter/DatePicker");
var _dialog = require("tailwind-starter/Dialog");
var _dropZone = require("tailwind-starter/DropZone");
var _form = require("tailwind-starter/Form");
var _date = require("@internationalized/date");
var _plants = require("./plants");
var _plantsDefault = parcelHelpers.interopDefault(_plants);
var _select = require("tailwind-starter/Select");
var _textField = require("tailwind-starter/TextField");
var _labels = require("./Labels");
var _react = require("react");
function PlantDialog({ item, onSave }) {
    let [droppedImage, setDroppedImage] = (0, _react.useState)(item?.default_image?.thumbnail);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
        children: ({ close })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                        slot: "title",
                        className: "text-2xl font-semibold leading-6 my-0 text-slate-700 dark:text-zinc-300",
                        children: item ? 'Edit Plant' : 'Add Plant'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                        action: (formData)=>{
                            let data = Object.fromEntries(formData);
                            data.sunlight = [
                                data.sunlight
                            ];
                            data.scientific_name = [
                                data.scientific_name
                            ];
                            data.default_image = {
                                thumbnail: data.image
                            };
                            data.id = item?.id || Date.now();
                            data.isFavorite = item?.isFavorite || false;
                            onSave(data);
                        },
                        className: "mt-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex gap-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropZone.DropZone), {
                                        getDropOperation: (types)=>types.has('image/jpeg') || types.has('image/png') ? 'copy' : 'cancel',
                                        onDrop: async (e)=>{
                                            let item = e.items.filter((0, _reactAriaComponents.isFileDropItem)).find((item)=>item.type === 'image/jpeg' || item.type === 'image/png');
                                            if (item) setDroppedImage(URL.createObjectURL(await item.getFile()));
                                        },
                                        className: "w-24 sm:w-32 p-2",
                                        children: [
                                            droppedImage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                alt: "",
                                                src: droppedImage,
                                                className: "w-full h-full object-contain aspect-square"
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                                                slot: "label",
                                                className: "italic text-sm text-center",
                                                children: "Drop or paste image here"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "hidden",
                                                name: "image",
                                                value: droppedImage
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-col gap-3 flex-1 min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comboBox.ComboBox), {
                                                label: "Common Name",
                                                name: "common_name",
                                                isRequired: true,
                                                items: (0, _plantsDefault.default),
                                                defaultInputValue: item?.common_name,
                                                allowsCustomValue: true,
                                                autoFocus: navigator.maxTouchPoints === 0,
                                                children: (plant)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comboBox.ComboBoxItem), {
                                                        children: plant.common_name
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textField.TextField), {
                                                label: "Scientific Name",
                                                name: "scientific_name",
                                                isRequired: true,
                                                defaultValue: item?.scientific_name?.join('')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                label: "Cycle",
                                name: "cycle",
                                isRequired: true,
                                defaultSelectedKey: item?.cycle,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Perennial",
                                        textValue: "Perennial",
                                        children: [
                                            (0, _labels.cycleIcon),
                                            " Perennial"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Annual",
                                        textValue: "Annual",
                                        children: [
                                            (0, _labels.cycleIcon),
                                            " Annual"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                label: "Sunlight",
                                name: "sunlight",
                                isRequired: true,
                                defaultSelectedKey: item ? (0, _labels.getSunlight)(item) : undefined,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "full sun",
                                        textValue: "Full Sun",
                                        children: [
                                            (0, _labels.sunIcons)['full sun'],
                                            " Full Sun"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "part sun",
                                        textValue: "Part Sun",
                                        children: [
                                            (0, _labels.sunIcons)['part sun'],
                                            " Part Sun"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "part shade",
                                        textValue: "Part Shade",
                                        children: [
                                            (0, _labels.sunIcons)['part shade'],
                                            " Part Shade"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                label: "Watering",
                                name: "watering",
                                isRequired: true,
                                defaultSelectedKey: item?.watering,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Frequent",
                                        textValue: "Frequent",
                                        children: [
                                            (0, _labels.wateringIcons)['Frequent'],
                                            " Frequent"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Average",
                                        textValue: "Average",
                                        children: [
                                            (0, _labels.wateringIcons)['Average'],
                                            " Average"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                        id: "Minimum",
                                        textValue: "Minimum",
                                        children: [
                                            (0, _labels.wateringIcons)['Minimum'],
                                            " Minimum"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePicker.DatePicker), {
                                label: "Date Planted",
                                isRequired: true,
                                defaultValue: item ? (0, _date.today)((0, _date.getLocalTimeZone)()) : null
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-6 flex justify-end gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "secondary",
                                        onPress: close,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "primary",
                                        type: "submit",
                                        children: item ? 'Save' : 'Add'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/Button":"hk9LL","react-aria-components":[["Heading","2f4nH"],["isFileDropItem","gR4JY"],["Text","jt9fm"]],"tailwind-starter/ComboBox":"3jskB","tailwind-starter/DatePicker":"b5U0H","tailwind-starter/Dialog":"cRN3c","tailwind-starter/DropZone":"24iCU","tailwind-starter/Form":"ruoBy","@internationalized/date":"1rmIt","./plants":"2Wr3I","tailwind-starter/Select":"gYM2m","tailwind-starter/TextField":"lhOW9","./Labels":"5mUiz","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gR4JY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "droppableCollectionMap", ()=>droppableCollectionMap);
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>DIRECTORY_DRAG_TYPE);
parcelHelpers.export(exports, "getDroppableCollectionId", ()=>getDroppableCollectionId);
parcelHelpers.export(exports, "getDroppableCollectionRef", ()=>getDroppableCollectionRef);
parcelHelpers.export(exports, "getTypes", ()=>getTypes);
parcelHelpers.export(exports, "useDragModality", ()=>useDragModality);
parcelHelpers.export(exports, "getDragModality", ()=>getDragModality);
parcelHelpers.export(exports, "writeToDataTransfer", ()=>writeToDataTransfer);
parcelHelpers.export(exports, "DragTypes", ()=>DragTypes);
parcelHelpers.export(exports, "readFromDataTransfer", ()=>readFromDataTransfer);
/** Returns whether a drop item contains text data. */ parcelHelpers.export(exports, "isTextDropItem", ()=>isTextDropItem);
/** Returns whether a drop item is a file. */ parcelHelpers.export(exports, "isFileDropItem", ()=>isFileDropItem);
/** Returns whether a drop item is a directory. */ parcelHelpers.export(exports, "isDirectoryDropItem", ()=>isDirectoryDropItem);
parcelHelpers.export(exports, "globalDndState", ()=>globalDndState);
parcelHelpers.export(exports, "setDraggingCollectionRef", ()=>setDraggingCollectionRef);
parcelHelpers.export(exports, "setDraggingKeys", ()=>setDraggingKeys);
parcelHelpers.export(exports, "setDropCollectionRef", ()=>setDropCollectionRef);
parcelHelpers.export(exports, "clearGlobalDnDState", ()=>clearGlobalDnDState);
parcelHelpers.export(exports, "setGlobalDnDState", ()=>setGlobalDnDState);
// Util function to check if the current dragging collection ref is the same as the current targeted droppable collection ref.
// Allows a droppable ref arg in case the global drop collection ref hasn't been set
parcelHelpers.export(exports, "isInternalDropOperation", ()=>isInternalDropOperation);
parcelHelpers.export(exports, "globalDropEffect", ()=>globalDropEffect);
parcelHelpers.export(exports, "setGlobalDropEffect", ()=>setGlobalDropEffect);
parcelHelpers.export(exports, "globalAllowedDropOperations", ()=>globalAllowedDropOperations);
parcelHelpers.export(exports, "setGlobalAllowedDropOperations", ()=>setGlobalAllowedDropOperations);
var _constants = require("./constants");
var _interactions = require("@react-aria/interactions");
const droppableCollectionMap = new WeakMap();
const DIRECTORY_DRAG_TYPE = Symbol();
function getDroppableCollectionId(state) {
    let { id } = droppableCollectionMap.get(state) || {};
    if (!id) throw new Error('Droppable item outside a droppable collection');
    return id;
}
function getDroppableCollectionRef(state) {
    let { ref } = droppableCollectionMap.get(state) || {};
    if (!ref) throw new Error('Droppable item outside a droppable collection');
    return ref;
}
function getTypes(items) {
    let types = new Set();
    for (let item of items)for (let type of Object.keys(item))types.add(type);
    return types;
}
function mapModality(modality) {
    if (!modality) modality = 'virtual';
    if (modality === 'pointer') modality = 'virtual';
    if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'touch';
    return modality;
}
function useDragModality() {
    return mapModality((0, _interactions.useInteractionModality)());
}
function getDragModality() {
    return mapModality((0, _interactions.getInteractionModality)());
}
function writeToDataTransfer(dataTransfer, items) {
    // The data transfer API doesn't support more than one item of a given type at once.
    // In addition, only a small set of types are supported natively for transfer between applications.
    // We allow for both multiple items, as well as multiple representations of a single item.
    // In order to make our API work with the native API, we serialize all items to JSON and
    // store as a single native item. We only need to do this if there is more than one item
    // of the same type, or if an item has more than one representation. Otherwise the native
    // API is sufficient.
    //
    // The DataTransferItemList API also theoretically supports adding files, which would enable
    // dragging binary data out of the browser onto the user's desktop for example. Unfortunately,
    // this does not currently work in any browser, so it is not currently supported by our API.
    // See e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=438479.
    let groupedByType = new Map();
    let needsCustomData = false;
    let customData = [];
    for (let item of items){
        let types = Object.keys(item);
        if (types.length > 1) needsCustomData = true;
        let dataByType = {};
        for (let type of types){
            let typeItems = groupedByType.get(type);
            if (!typeItems) {
                typeItems = [];
                groupedByType.set(type, typeItems);
            } else needsCustomData = true;
            let data = item[type];
            dataByType[type] = data;
            typeItems.push(data);
        }
        customData.push(dataByType);
    }
    for (let [type, items] of groupedByType)if ((0, _constants.NATIVE_DRAG_TYPES).has(type)) {
        // Only one item of a given type can be set on a data transfer.
        // Join all of the items together separated by newlines.
        let data = items.join('\n');
        dataTransfer.items.add(data, type);
    } else // Set data to the first item so we have access to the list of types.
    dataTransfer.items.add(items[0], type);
    if (needsCustomData) {
        let data = JSON.stringify(customData);
        dataTransfer.items.add(data, (0, _constants.CUSTOM_DRAG_TYPE));
    }
}
class DragTypes {
    constructor(dataTransfer){
        this.types = new Set();
        let hasFiles = false;
        for (let item of dataTransfer.items)if (item.type !== (0, _constants.CUSTOM_DRAG_TYPE)) {
            if (item.kind === 'file') hasFiles = true;
            if (item.type) this.types.add(item.type);
            else // Files with unknown types or extensions that don't map to a known mime type
            // are sometimes exposed as an empty string by the browser. Map to a generic
            // mime type instead. Note that this could also be a directory as there's no
            // way to determine if something is a file or directory until drop.
            this.types.add((0, _constants.GENERIC_TYPE));
        }
        // In Safari, when dragging files, the dataTransfer.items list is empty, but dataTransfer.types contains "Files".
        // Unfortunately, this doesn't tell us what types of files the user is dragging, so we need to assume that any
        // type the user checks for is included. See https://bugs.webkit.org/show_bug.cgi?id=223517.
        this.includesUnknownTypes = !hasFiles && dataTransfer.types.includes('Files');
    }
    has(type) {
        if (this.includesUnknownTypes || type === DIRECTORY_DRAG_TYPE && this.types.has((0, _constants.GENERIC_TYPE))) return true;
        return typeof type === 'string' && this.types.has(type);
    }
}
function readFromDataTransfer(dataTransfer) {
    let items = [];
    if (!dataTransfer) return items;
    // If our custom drag type is available, use that. This is a JSON serialized
    // representation of all items in the drag, set when there are multiple items
    // of the same type, or an individual item has multiple representations.
    let hasCustomType = false;
    if (dataTransfer.types.includes((0, _constants.CUSTOM_DRAG_TYPE))) try {
        let data = dataTransfer.getData((0, _constants.CUSTOM_DRAG_TYPE));
        let parsed = JSON.parse(data);
        for (let item of parsed)items.push({
            kind: 'text',
            types: new Set(Object.keys(item)),
            getText: (type)=>Promise.resolve(item[type])
        });
        hasCustomType = true;
    } catch  {
    // ignore
    }
    // Otherwise, map native drag items to items of a single representation.
    if (!hasCustomType) {
        let stringItems = new Map();
        for (let item of dataTransfer.items){
            if (item.kind === 'string') // The data for all formats must be read here because the data transfer gets
            // cleared out after the event handler finishes. If the item has an empty string
            // as a type, the mime type is unknown. Map to a generic mime type instead.
            stringItems.set(item.type || (0, _constants.GENERIC_TYPE), dataTransfer.getData(item.type));
            else if (item.kind === 'file') {
                // Despite the name, webkitGetAsEntry is also implemented in Firefox and Edge.
                // In the future, we may use getAsFileSystemHandle instead, but that's currently
                // only implemented in Chrome.
                if (typeof item.webkitGetAsEntry === 'function') {
                    let entry = item.webkitGetAsEntry();
                    // eslint-disable-next-line max-depth
                    if (!entry) continue;
                    // eslint-disable-next-line max-depth
                    if (entry.isFile) items.push(createFileItem(item.getAsFile()));
                    else if (entry.isDirectory) items.push(createDirectoryItem(entry));
                } else // Assume it's a file.
                items.push(createFileItem(item.getAsFile()));
            }
        }
        // All string items are different representations of the same item. There's no way to have
        // multiple string items at once in the current DataTransfer API.
        if (stringItems.size > 0) items.push({
            kind: 'text',
            types: new Set(stringItems.keys()),
            getText: (type)=>Promise.resolve(stringItems.get(type))
        });
    }
    return items;
}
function blobToString(blob) {
    if (typeof blob.text === 'function') return blob.text();
    // Safari doesn't have the Blob#text() method yet...
    return new Promise((resolve, reject)=>{
        let reader = new FileReader;
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(blob);
    });
}
function createFileItem(file) {
    if (!file) throw new Error('No file provided');
    return {
        kind: 'file',
        type: file.type || (0, _constants.GENERIC_TYPE),
        name: file.name,
        getText: ()=>blobToString(file),
        getFile: ()=>Promise.resolve(file)
    };
}
function createDirectoryItem(entry) {
    return {
        kind: 'directory',
        name: entry.name,
        getEntries: ()=>getEntries(entry)
    };
}
async function* getEntries(item) {
    let reader = item.createReader();
    // We must call readEntries repeatedly because there may be a limit to the
    // number of entries that are returned at once.
    let entries;
    do {
        entries = await new Promise((resolve, reject)=>{
            reader.readEntries(resolve, reject);
        });
        for (let entry of entries){
            if (entry.isFile) {
                let file = await getEntryFile(entry);
                yield createFileItem(file);
            } else if (entry.isDirectory) yield createDirectoryItem(entry);
        }
    }while (entries.length > 0);
}
function getEntryFile(entry) {
    return new Promise((resolve, reject)=>entry.file(resolve, reject));
}
function isTextDropItem(dropItem) {
    return dropItem.kind === 'text';
}
function isFileDropItem(dropItem) {
    return dropItem.kind === 'file';
}
function isDirectoryDropItem(dropItem) {
    return dropItem.kind === 'directory';
}
let globalDndState = {
    draggingKeys: new Set()
};
function setDraggingCollectionRef(ref) {
    globalDndState.draggingCollectionRef = ref;
}
function setDraggingKeys(keys) {
    globalDndState.draggingKeys = keys;
}
function setDropCollectionRef(ref) {
    globalDndState.dropCollectionRef = ref;
}
function clearGlobalDnDState() {
    globalDndState = {
        draggingKeys: new Set()
    };
}
function setGlobalDnDState(state) {
    globalDndState = state;
}
function isInternalDropOperation(ref) {
    let { draggingCollectionRef, dropCollectionRef } = globalDndState;
    return draggingCollectionRef?.current != null && draggingCollectionRef.current === (ref?.current || dropCollectionRef?.current);
}
let globalDropEffect;
function setGlobalDropEffect(dropEffect) {
    globalDropEffect = dropEffect;
}
let globalAllowedDropOperations = (0, _constants.DROP_OPERATION).none;
function setGlobalAllowedDropOperations(o) {
    globalAllowedDropOperations = o;
}

},{"./constants":"dL7d2","@react-aria/interactions":"dkfxW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dL7d2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DROP_OPERATION", ()=>DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_ALLOWED", ()=>DROP_OPERATION_ALLOWED);
parcelHelpers.export(exports, "EFFECT_ALLOWED", ()=>EFFECT_ALLOWED);
parcelHelpers.export(exports, "DROP_EFFECT_TO_DROP_OPERATION", ()=>DROP_EFFECT_TO_DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_TO_DROP_EFFECT", ()=>DROP_OPERATION_TO_DROP_EFFECT);
parcelHelpers.export(exports, "NATIVE_DRAG_TYPES", ()=>NATIVE_DRAG_TYPES);
parcelHelpers.export(exports, "CUSTOM_DRAG_TYPE", ()=>CUSTOM_DRAG_TYPE);
parcelHelpers.export(exports, "GENERIC_TYPE", ()=>GENERIC_TYPE);
var DROP_OPERATION = /*#__PURE__*/ function(DROP_OPERATION) {
    DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
    DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
    DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
    DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
    DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
    DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
    return DROP_OPERATION;
}({});
const DROP_OPERATION_ALLOWED = {
    ...DROP_OPERATION,
    copyMove: 3,
    copyLink: 6,
    linkMove: 5,
    all: 7,
    uninitialized: 7
};
const EFFECT_ALLOWED = invert(DROP_OPERATION_ALLOWED);
EFFECT_ALLOWED[7] = 'all'; // ensure we don't map to 'uninitialized'.
const DROP_EFFECT_TO_DROP_OPERATION = {
    none: 'cancel',
    link: 'link',
    copy: 'copy',
    move: 'move'
};
const DROP_OPERATION_TO_DROP_EFFECT = invert(DROP_EFFECT_TO_DROP_OPERATION);
function invert(object) {
    let res = {};
    for(let key in object)res[object[key]] = key;
    return res;
}
const NATIVE_DRAG_TYPES = new Set([
    'text/plain',
    'text/uri-list',
    'text/html'
]);
const CUSTOM_DRAG_TYPE = 'application/vnd.react-aria.items+json';
const GENERIC_TYPE = 'application/octet-stream';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3jskB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBox", ()=>ComboBox);
parcelHelpers.export(exports, "ComboBoxItem", ()=>ComboBoxItem);
parcelHelpers.export(exports, "ComboBoxSection", ()=>ComboBoxSection);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _field = require("./Field");
var _listBox = require("./ListBox");
var _popover = require("./Popover");
var _utils = require("./utils");
var _fieldButton = require("./FieldButton");
'use client';
function ComboBox({ label, description, errorMessage, children, items, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ComboBox), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 font-sans'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldButton.FieldButton), {
                        className: "w-6 mr-1 rounded-sm outline-offset-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                className: "w-(--trigger-width)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                    items: items,
                    className: "outline-0 p-1 box-border max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]",
                    children: children
                })
            })
        ]
    });
}
function ComboBoxItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.DropdownItem), {
        ...props
    });
}
function ComboBoxSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.DropdownSection), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ChevronDown","kWVt3","default"]],"react":"a1TxN","react-aria-components":[["ComboBox","aR9kO"],["ListBox","dNdIK"]],"./Field":"5fXWs","./ListBox":"4YPUR","./Popover":"Dr9D3","./utils":"jNXji","./FieldButton":"9xJpc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kWVt3":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const ChevronDown = (0, _createLucideIconJsDefault.default)("chevron-down", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b5U0H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>DatePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _calendar = require("./Calendar");
var _dateField = require("./DateField");
var _dialog = require("./Dialog");
var _field = require("./Field");
var _popover = require("./Popover");
var _utils = require("./utils");
var _fieldButton = require("./FieldButton");
'use client';
function DatePicker({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DatePicker), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 font-sans'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                className: "min-w-[208px] w-auto",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                        className: "flex-1 min-w-[150px] px-2 py-1.5 text-sm"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldButton.FieldButton), {
                        className: "w-6 mr-1 rounded-sm outline-offset-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CalendarIcon), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.Calendar), {})
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["CalendarIcon","79VlQ","default"]],"react":"a1TxN","react-aria-components":"59rph","./Calendar":"hFRUB","./DateField":"bPyay","./Dialog":"cRN3c","./Field":"5fXWs","./Popover":"Dr9D3","./utils":"jNXji","./FieldButton":"9xJpc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"79VlQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Calendar);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const Calendar = (0, _createLucideIconJsDefault.default)("calendar", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hFRUB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
parcelHelpers.export(exports, "CalendarHeader", ()=>CalendarHeader);
parcelHelpers.export(exports, "CalendarGridHeader", ()=>CalendarGridHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _button = require("./Button");
var _utils = require("./utils");
'use client';
const cellStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'w-9 h-9 text-sm cursor-default rounded-full flex items-center justify-center forced-color-adjust-none',
    variants: {
        isSelected: {
            false: 'text-zinc-900 dark:text-zinc-200 hover:bg-gray-100 dark:hover:bg-zinc-700 pressed:bg-gray-200 dark:pressed:bg-zinc-600',
            true: 'bg-blue-600 invalid:bg-red-600 text-white forced-colors:bg-[Highlight] forced-colors:invalid:bg-[Mark] forced-colors:text-[HighlightText]'
        },
        isDisabled: {
            true: 'text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    }
});
function Calendar({ errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Calendar), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col font-sans'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarHeader, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.CalendarGrid), {
                className: "border-spacing-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarGridHeader, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarGridBody), {
                        children: (date)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarCell), {
                                date: date,
                                className: cellStyles
                            })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                slot: "errorMessage",
                className: "text-sm text-red-600",
                children: errorMessage
            })
        ]
    });
}
function CalendarHeader() {
    let { direction } = (0, _reactAriaComponents.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
        className: "flex items-center gap-1 pb-4 px-1 border-box",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "secondary",
                slot: "previous",
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                    "aria-hidden": true,
                    size: 18
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                    "aria-hidden": true,
                    size: 18
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                className: "flex-1 font-sans font-semibold [font-variation-settings:normal] text-lg text-center mx-2 text-zinc-900 dark:text-zinc-200"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "secondary",
                slot: "next",
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                    "aria-hidden": true,
                    size: 18
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                    "aria-hidden": true,
                    size: 18
                })
            })
        ]
    });
}
function CalendarGridHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarGridHeader), {
        children: (day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarHeaderCell), {
                className: "text-xs text-gray-500 font-semibold",
                children: day
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ChevronLeft","6gHLa","default"],["ChevronRight","elAlB","default"]],"react":"a1TxN","react-aria-components":[["Calendar","2DleA"],["CalendarCell","2DleA"],["CalendarGrid","2DleA"],["CalendarGridBody","2DleA"],["CalendarGridHeader","2DleA"],["CalendarHeaderCell","2DleA"],["Heading","2f4nH"],["Text","jt9fm"],["useLocale","4k4z8"]],"tailwind-variants":"dpXBU","./Button":"hk9LL","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6gHLa":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronLeft);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const ChevronLeft = (0, _createLucideIconJsDefault.default)("chevron-left", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bPyay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateField", ()=>DateField);
parcelHelpers.export(exports, "DateInput", ()=>DateInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
function DateField({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DateField), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col gap-1'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            })
        ]
    });
}
const segmentStyles = (0, _tailwindVariants.tv)({
    base: 'inline p-0.5 type-literal:px-0 rounded-xs outline outline-0 forced-color-adjust-none caret-transparent text-gray-800 dark:text-zinc-200 forced-colors:text-[ButtonText]',
    variants: {
        isPlaceholder: {
            true: 'text-gray-600 dark:text-zinc-400 italic'
        },
        isDisabled: {
            true: 'text-gray-200 dark:text-zinc-600 forced-colors:text-[GrayText]'
        },
        isFocused: {
            true: 'bg-blue-600 text-white dark:text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]'
        }
    }
});
function DateInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateInput), {
        className: (renderProps)=>(0, _field.fieldGroupStyles)({
                ...renderProps,
                class: 'inline min-w-[150px] px-2 py-1.5 text-sm font-sans whitespace-nowrap overflow-x-auto [scrollbar-width:none]'
            }),
        ...props,
        children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateSegment), {
                segment: segment,
                className: segmentStyles
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"5wv9P","tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"24iCU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZone", ()=>DropZone);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
'use client';
const dropZone = (0, _tailwindVariants.tv)({
    base: "flex items-center justify-center p-8 min-h-24 w-[30%] font-sans text-base text-balance text-center rounded-lg border border-1 border-gray-300 dark:border-zinc-800 bg-white dark:bg-zinc-900",
    variants: {
        isFocusVisible: {
            true: "outline outline-2 -outline-offset-1 outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight]"
        },
        isDropTarget: {
            true: "bg-blue-200 dark:bg-blue-800 outline outline-2 -outline-offset-1 outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight]"
        }
    }
});
function DropZone(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DropZone), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>dropZone({
                ...renderProps,
                className
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["composeRenderProps","bA6Cz"],["DropZone","8r9g2"]],"tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8r9g2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZoneContext", ()=>DropZoneContext);
parcelHelpers.export(exports, "DropZone", ()=>DropZone);
var _utils = require("./utils");
var _reactAria = require("react-aria");
var _utils1 = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const DropZoneContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DropZone = /*#__PURE__*/ (0, _react.forwardRef)(function DropZone(props, ref) {
    let { isDisabled = false } = props;
    [props, ref] = (0, _utils.useContextProps)(props, ref, DropZoneContext);
    let dropzoneRef = (0, _utils1.useObjectRef)(ref);
    let buttonRef = (0, _react.useRef)(null);
    let { dropProps, dropButtonProps, isDropTarget } = (0, _reactAria.useDrop)({
        ...props,
        ref: buttonRef,
        hasDropButton: true
    });
    let { buttonProps } = (0, _reactAria.useButton)(dropButtonProps || {}, buttonRef);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let stringFormatter = (0, _reactAria.useLocalizedStringFormatter)((0, _jsonDefault.default), 'react-aria-components');
    let textId = (0, _utils1.useSlotId)();
    let ariaLabel = props['aria-label'] || stringFormatter.format('dropzoneLabel');
    let messageId = props['aria-labelledby'];
    let ariaLabelledby = [
        textId,
        messageId
    ].filter(Boolean).join(' ');
    let labelProps = (0, _utils1.useLabels)({
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    let { clipboardProps } = (0, _reactAria.useClipboard)({
        isDisabled,
        onPaste: (items)=>props.onDrop?.({
                type: 'drop',
                items,
                x: 0,
                y: 0,
                dropOperation: 'copy'
            })
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isFocused,
            isFocusVisible,
            isDropTarget,
            isDisabled
        },
        defaultClassName: 'react-aria-DropZone'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _text.TextContext),
                {
                    id: textId,
                    slot: 'label'
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, dropProps, hoverProps),
        slot: props.slot || undefined,
        ref: dropzoneRef,
        onClick: (e)=>{
            let target = e.target;
            while(target && dropzoneRef.current?.contains(target)){
                if ((0, _utils1.isFocusable)(target)) break;
                else if (target === dropzoneRef.current) {
                    buttonRef.current?.focus();
                    break;
                }
                target = target.parentElement;
            }
        },
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-drop-target": isDropTarget || undefined,
        "data-disabled": isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _reactAria.mergeProps)(buttonProps, focusProps, clipboardProps, labelProps),
        ref: buttonRef
    })), renderProps.children));
});

},{"./utils":"bA6Cz","react-aria":[["mergeProps","aNvcY"],["useButton","exEOU"],["useClipboard","5RCSJ"],["useDrop","k4cyN"],["useFocusRing","6TXyU"],["useHover","k6FLA"],["useLocalizedStringFormatter","7lxyl"],["VisuallyHidden","7zrGr"]],"@react-aria/utils":[["filterDOMProps","3upVm"],["isFocusable","72VDv"],["useLabels","7Uhyw"],["useObjectRef","laqO5"],["useSlotId","jbI4Y"]],"../intl/*.json":"ibVl8","react":"a1TxN","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5RCSJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles clipboard interactions for a focusable element. Supports items of multiple
 * data types, and integrates with the operating system native clipboard.
 */ parcelHelpers.export(exports, "useClipboard", ()=>useClipboard);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
const globalEvents = new Map();
function addGlobalEventListener(event, fn) {
    let eventData = globalEvents.get(event);
    if (!eventData) {
        let handlers = new Set();
        let listener = (e)=>{
            for (let handler of handlers)handler(e);
        };
        eventData = {
            listener,
            handlers
        };
        globalEvents.set(event, eventData);
        document.addEventListener(event, listener);
    }
    eventData.handlers.add(fn);
    return ()=>{
        eventData.handlers.delete(fn);
        if (eventData.handlers.size === 0) {
            document.removeEventListener(event, eventData.listener);
            globalEvents.delete(event);
        }
    };
}
function useClipboard(options) {
    let { isDisabled } = options;
    let isFocusedRef = (0, _react.useRef)(false);
    let { focusProps } = (0, _interactions.useFocus)({
        onFocusChange: (isFocused)=>{
            isFocusedRef.current = isFocused;
        }
    });
    let onBeforeCopy = (0, _utils.useEffectEvent)((e)=>{
        // Enable the "Copy" menu item in Safari if this element is focused and copying is supported.
        if (isFocusedRef.current && options.getItems) e.preventDefault();
    });
    let onCopy = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.getItems) return;
        e.preventDefault();
        if (e.clipboardData) {
            (0, _utils1.writeToDataTransfer)(e.clipboardData, options.getItems({
                action: 'copy'
            }));
            options.onCopy?.();
        }
    });
    let onBeforeCut = (0, _utils.useEffectEvent)((e)=>{
        if (isFocusedRef.current && options.onCut && options.getItems) e.preventDefault();
    });
    let onCut = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onCut || !options.getItems) return;
        e.preventDefault();
        if (e.clipboardData) {
            (0, _utils1.writeToDataTransfer)(e.clipboardData, options.getItems({
                action: 'cut'
            }));
            options.onCut();
        }
    });
    let onBeforePaste = (0, _utils.useEffectEvent)((e)=>{
        // Unfortunately, e.clipboardData.types is not available in this event so we always
        // have to enable the Paste menu item even if the type of data is unsupported.
        if (isFocusedRef.current && options.onPaste) e.preventDefault();
    });
    let onPaste = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onPaste) return;
        e.preventDefault();
        if (e.clipboardData) {
            let items = (0, _utils1.readFromDataTransfer)(e.clipboardData);
            options.onPaste(items);
        }
    });
    (0, _react.useEffect)(()=>{
        if (isDisabled) return;
        return (0, _utils.chain)(addGlobalEventListener('beforecopy', onBeforeCopy), addGlobalEventListener('copy', onCopy), addGlobalEventListener('beforecut', onBeforeCut), addGlobalEventListener('cut', onCut), addGlobalEventListener('beforepaste', onBeforePaste), addGlobalEventListener('paste', onPaste));
    }, [
        isDisabled
    ]);
    return {
        clipboardProps: focusProps
    };
}

},{"@react-aria/utils":[["chain","ij7eS"],["useEffectEvent","eg4dC"]],"./utils":"gR4JY","react":"a1TxN","@react-aria/interactions":"j8nkn","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ruoBy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>Form);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
'use client';
function Form(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Form), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('flex flex-col gap-4', props.className)
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"g7RKA","tailwind-merge":"lEVAz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gYM2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
parcelHelpers.export(exports, "SelectItem", ()=>SelectItem);
parcelHelpers.export(exports, "SelectSection", ()=>SelectSection);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _listBox = require("./ListBox");
var _popover = require("./Popover");
var _utils = require("./utils");
'use client';
const styles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'flex items-center text-start gap-4 w-full cursor-default border border-black/10 dark:border-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none rounded-lg pl-3 pr-2 py-2 min-w-[150px] transition bg-gray-50 dark:bg-zinc-900',
    variants: {
        isDisabled: {
            false: 'text-gray-800 dark:text-zinc-300 hover:bg-gray-100 pressed:bg-gray-200 dark:hover:bg-zinc-800 dark:pressed:bg-zinc-700 group-invalid:border-red-600 forced-colors:group-invalid:border-[Mark]',
            true: 'text-gray-200 dark:text-zinc-600 forced-colors:text-[GrayText] dark:bg-zinc-800 dark:border-white/5 forced-colors:border-[GrayText]'
        }
    }
});
function Select({ label, description, errorMessage, children, items, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Select), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 relative font-sans'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
                className: styles,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SelectValue), {
                        className: "flex-1 text-sm placeholder-shown:italic",
                        children: ({ selectedText, defaultChildren })=>selectedText || defaultChildren
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                        "aria-hidden": true,
                        className: "w-4 h-4 text-gray-600 dark:text-zinc-400 forced-colors:text-[ButtonText] group-disabled:text-gray-200 dark:group-disabled:text-zinc-600 forced-colors:group-disabled:text-[GrayText]"
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                className: "min-w-(--trigger-width)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                    items: items,
                    className: "outline-hidden box-border p-1 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]",
                    children: children
                })
            })
        ]
    });
}
function SelectItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.DropdownItem), {
        ...props
    });
}
function SelectSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.DropdownSection), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ChevronDown","kWVt3","default"]],"react":"a1TxN","react-aria-components":[["Button","9G5XO"],["ListBox","dNdIK"],["Select","f92ET"],["SelectValue","f92ET"]],"tailwind-variants":"dpXBU","./Field":"5fXWs","./ListBox":"4YPUR","./Popover":"Dr9D3","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lhOW9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", ()=>TextField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
const inputStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'border-2 rounded-lg',
    variants: {
        isFocused: (0, _field.fieldBorderStyles).variants.isFocusWithin,
        isInvalid: (0, _field.fieldBorderStyles).variants.isInvalid,
        isDisabled: (0, _field.fieldBorderStyles).variants.isDisabled
    }
});
function TextField({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TextField), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col gap-1 font-sans'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                className: inputStyles
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"3CtQI","tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3Y0eO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* Rendered on mobile in place of the PlantTable */ parcelHelpers.export(exports, "PlantList", ()=>PlantList);
var _jsxRuntime = require("react/jsx-runtime");
var _gridList = require("tailwind-starter/GridList");
var _plantActionMenu = require("./PlantActionMenu");
"use client";
function PlantList(props) {
    let { items, onFavoriteChange, onEdit, onDelete } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridList), {
        "aria-label": "My plants",
        selectionMode: "multiple",
        items: items,
        renderEmptyState: ()=>'No results. Try changing the filters.',
        className: "h-[320px] w-full md:!hidden",
        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridListItem), {
                textValue: item.common_name,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid grid-cols-[40px_1fr_auto] gap-x-2 w-full",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            alt: "",
                            src: item.default_image?.thumbnail,
                            className: "inline rounded-sm row-span-2 object-contain h-[40px]"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "truncate capitalize",
                            children: item.common_name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "truncate text-xs text-gray-600 dark:text-zinc-400 col-start-2 row-start-2",
                            children: item.scientific_name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _plantActionMenu.PlantActionMenu), {
                            item: item,
                            onFavoriteChange: onFavoriteChange,
                            onEdit: onEdit,
                            onDelete: onDelete
                        })
                    ]
                })
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","tailwind-starter/GridList":"4hFdV","./PlantActionMenu":"3MHuH","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4hFdV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridList", ()=>GridList);
parcelHelpers.export(exports, "GridListItem", ()=>GridListItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _checkbox = require("./Checkbox");
var _utils = require("./utils");
'use client';
function GridList({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridList), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'overflow-auto w-[200px] relative bg-white dark:bg-zinc-900 border border-gray-300 dark:border-zinc-600 rounded-lg font-sans empty:flex empty:items-center empty:justify-center empty:italic empty:text-sm'),
        children: children
    });
}
const itemStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'relative flex gap-3 cursor-default select-none py-2 px-3 text-sm text-gray-900 dark:text-zinc-200 border-y dark:border-y-zinc-700 border-transparent first:border-t-0 last:border-b-0 first:rounded-t-lg last:rounded-b-lg -mb-px last:mb-0 -outline-offset-2',
    variants: {
        isSelected: {
            false: 'hover:bg-gray-100 dark:hover:bg-zinc-700/60',
            true: 'bg-blue-100 dark:bg-blue-700/30 hover:bg-blue-200 dark:hover:bg-blue-700/40 border-y-blue-200 dark:border-y-blue-900 z-20'
        },
        isDisabled: {
            true: 'text-slate-300 dark:text-zinc-600 forced-colors:text-[GrayText] z-10'
        }
    }
});
function GridListItem({ children, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridListItem), {
        textValue: textValue,
        ...props,
        className: itemStyles,
        children: (0, _reactAriaComponents.composeRenderProps)(children, (children, { selectionMode, selectionBehavior, allowsDragging })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "drag",
                        children: "\u2261"
                    }),
                    selectionMode === 'multiple' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                        slot: "selection"
                    }),
                    children
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"],["GridList","8bLgh"],["GridListItem","8bLgh"]],"tailwind-variants":"dpXBU","./Checkbox":"9J9Ug","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PPGS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a list component with interactive children.
 * A grid list displays data in a single column and enables a user to navigate its contents via directional navigation keys.
 * @param props - Props for the list.
 * @param state - State for the list, as returned by `useListState`.
 * @param ref - The ref attached to the list element.
 */ parcelHelpers.export(exports, "useGridList", ()=>useGridList);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _grid = require("@react-aria/grid");
var _focus = require("@react-aria/focus");
var _selection = require("@react-aria/selection");
function useGridList(props, state, ref) {
    let { isVirtualized, keyboardDelegate, layoutDelegate, onAction, disallowTypeAhead, linkBehavior = 'action', keyboardNavigationBehavior = 'arrow', escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps } = (0, _selection.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref,
        keyboardDelegate,
        layoutDelegate,
        isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior,
        disallowTypeAhead,
        autoFocus: props.autoFocus,
        escapeKeyBehavior
    });
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.listMap).set(state, {
        id,
        onAction,
        linkBehavior,
        keyboardNavigationBehavior,
        shouldSelectOnPressUp
    });
    let descriptionProps = (0, _grid.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, _focus.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, _utils.mergeProps)(domProps, {
        role: 'grid',
        id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, _grid.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useId","jbI4Y"]],"./utils":"aJkqW","@react-aria/grid":[["useGridSelectionAnnouncement","deyzk"],["useHighlightSelectionDescription","eO4Xt"]],"@react-aria/focus":"eSQu0","@react-aria/selection":"ldksp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aJkqW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listMap", ()=>listMap);
parcelHelpers.export(exports, "getRowId", ()=>getRowId);
parcelHelpers.export(exports, "normalizeKey", ()=>normalizeKey);
const listMap = new WeakMap();
function getRowId(state, key) {
    let { id } = listMap.get(state) ?? {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${normalizeKey(key)}`;
}
function normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fNHH4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a grid list.
 * @param props - Props for the row.
 * @param state - State of the parent list, as returned by `useListState`.
 * @param ref - The ref attached to the row element.
 */ parcelHelpers.export(exports, "useGridListItem", ()=>useGridListItem);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _selection = require("@react-aria/selection");
var _i18N = require("@react-aria/i18n");
const EXPANSION_KEYS = {
    'expand': {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function useGridListItem(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node, isVirtualized } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction } = (0, _i18N.useLocale)();
    let { onAction, linkBehavior, keyboardNavigationBehavior, shouldSelectOnPressUp } = (0, _utils1.listMap).get(state);
    let descriptionId = (0, _utils.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, _react.useRef)(null);
    let focus = ()=>{
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (ref.current !== null && (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current?.contains(document.activeElement))) (0, _focus.focusSafely)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows = props.hasChildItems;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = state.collection.getChildren?.(node.key);
        hasChildRows = hasChildRows || [
            ...children ?? []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        if (node.level > 0 && node?.parentKey != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                // siblings must exist because our original node exists
                let siblings = state.collection.getChildren?.(parent.key);
                setSize = [
                    ...siblings
                ].filter((row)=>row.type === 'item').length;
            }
        } else setSize = [
            ...state.collection
        ].filter((row)=>row.level === 0 && row.type === 'item').length;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': node?.index + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps, ...itemStates } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onAction || node.props?.onAction ? (0, _utils.chain)(node.props?.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus,
        linkBehavior
    });
    let onKeyDownCapture = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        if ('expandedKeys' in state && document.activeElement === ref.current) {
            if (e.key === EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            } else if (e.key === EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            }
        }
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, _interactions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, _focus.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = document.activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let syntheticLinkProps = (0, _utils.useSyntheticLinkProps)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    let rowProps = (0, _utils.mergeProps)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture,
        onKeyDown,
        onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && node.textValue ? `${(0, _utils1.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, _utils1.getRowId)(state, node.key)
    });
    if (isVirtualized) {
        let { collection } = state;
        let nodes = [
            ...collection
        ];
        // TODO: refactor ListCollection to store an absolute index of a node's position?
        rowProps['aria-rowindex'] = nodes.find((node)=>node.type === 'section') ? [
            ...collection.getKeys()
        ].filter((key)=>collection.getItem(key)?.type !== 'section').findIndex((key)=>key === node.key) + 1 : node.index + 1;
    }
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    return {
        rowProps: {
            ...(0, _utils.mergeProps)(rowProps, treeGridRowProps)
        },
        gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

},{"@react-aria/utils":[["chain","ij7eS"],["getScrollParent","1Tu7U"],["mergeProps","aNvcY"],["scrollIntoViewport","1lzpw"],["useSlotId","jbI4Y"],["useSyntheticLinkProps","4FGnT"]],"@react-aria/focus":[["focusSafely","2ysUy"],["getFocusableTreeWalker","9oPIl"]],"./utils":"aJkqW","react":"a1TxN","@react-aria/interactions":"dkfxW","@react-aria/selection":"cJdJS","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8WxyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid.
 * @param props - Props for the selection checkbox.
 * @param state - State of the grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>useGridSelectionCheckbox);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useGridSelectionCheckbox(props, state) {
    let { key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, _utils.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected,
            isDisabled,
            onChange
        }
    };
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"jbI4Y","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l0ABP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized date formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the date formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useDateFormatter", ()=>useDateFormatter);
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _context = require("./context");
var _react = require("react");
function useDateFormatter(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, _utils.useDeepMemo)(options ?? {}, isEqual);
    let { locale } = (0, _context.useLocale)();
    return (0, _react.useMemo)(()=>new (0, _date.DateFormatter)(locale, options), [
        locale,
        options
    ]);
}
function isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}

},{"@internationalized/date":"6ueXY","@react-aria/utils":"6otos","./context":"4k4z8","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6ueXY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** A wrapper around Intl.DateTimeFormat that fixes various browser bugs, and polyfills new features. */ parcelHelpers.export(exports, "DateFormatter", ()=>DateFormatter);
let formatterCache = new Map();
class DateFormatter {
    constructor(locale, options = {}){
        this.formatter = getCachedDateFormatter(locale, options);
        this.options = options;
    }
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === 'function') // @ts-ignore
        return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === 'function') // @ts-ignore
        return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if (hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === 'ethiopic-amete-alem') resolvedOptions.calendar = 'ethioaa';
        return resolvedOptions;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: 'h11'
    },
    false: {
    }
};
function getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === 'boolean' && hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = hour12Preferences[String(options.hour12)][locale.split('-')[0]];
        let defaultHourCycle = options.hour12 ? 'h12' : 'h23';
        options.hourCycle = pref ?? defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if (formatterCache.has(cacheKey)) return formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let _hasBuggyHour12Behavior = null;
function hasBuggyHour12Behavior() {
    if (_hasBuggyHour12Behavior == null) _hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
    return _hasBuggyHour12Behavior;
}
let _hasBuggyResolvedHourCycle = null;
function hasBuggyResolvedHourCycle() {
    if (_hasBuggyResolvedHourCycle == null) _hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
        hour: 'numeric',
        hour12: false
    }).resolvedOptions().hourCycle === 'h12';
    return _hasBuggyResolvedHourCycle;
}
function getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
    locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
    let formatter = getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === 'hour').value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === 'hour').value, 10);
    if (min === 0 && max === 23) return 'h23';
    if (min === 24 && max === 23) return 'h24';
    if (min === 0 && max === 11) return 'h11';
    if (min === 12 && max === 11) return 'h12';
    throw new Error('Unexpected hour cycle result');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6otos":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepMemo", ()=>useDeepMemo);
var _react = require("react");
function useDeepMemo(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, _react.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hH0ym":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid list.
 * @param props - Props for the selection checkbox.
 * @param state - State of the list, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useGridListSelectionCheckbox", ()=>useGridListSelectionCheckbox);
var _grid = require("@react-aria/grid");
var _utils = require("./utils");
function useGridListSelectionCheckbox(props, state) {
    let { key } = props;
    const { checkboxProps } = (0, _grid.useGridSelectionCheckbox)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            'aria-labelledby': `${checkboxProps.id} ${(0, _utils.getRowId)(state, key)}`
        }
    };
}

},{"@react-aria/grid":"8WxyV","./utils":"aJkqW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {}, "./", "https://reactspectrum.blob.core.windows.net/reactspectrum/d5c87e02c32251e37464fb6f47d9a5adc30df927/s2-docs/")

//# sourceMappingURL=crud.2ef066a2.js.map
